import { Image } from "primereact/image";
import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";

import Layout from "../../../components/common/nav/initiator/nav.component";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Auth, DataStore, Predicates, SortDirection } from "aws-amplify";
import { ValidateInitiatorRole } from "../../../helper/validateRole";
import { Column } from "primereact/column";
import { Sidebar } from "primereact/sidebar";
import { Tag } from "primereact/tag";
import sideBarRight from "../../../assets/images/sidebarright.svg";
import user1 from "../../../assets/images/user1.svg";
import user2 from "../../../assets/images/user2.svg";
import Editpopup from "../../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from "../../../setup/auth/login.component";
import sidebar from "../../../assets/images/sidebarright.svg";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import { Avatar } from "primereact/avatar";
import { ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForSelect } from "../../../helper/commonfunctions";
import {
  InitiateClassifiedWeeklyAbsenceReport,
  InitiateClassifiedWeeklyAbsenceReportStatus,
  Employee,
  Schools,
  Subject,
  SixthPeriodAssignmentInitiateReport
} from "../../../models";

import { PersonalActionForm } from "../../../models";
import w9DetailesPic from "../../../assets/svg/w9details.svg";
import moment from "moment";
import { Link } from "react-router-dom";
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { Calendar } from "primereact/calendar";
import empDetailsImg from "../../../assets/images/applicationImg.png";
import { toast } from "react-toastify";
import { Request_Status } from "../../../helper/enum";
import { reactLocalStorage } from "reactjs-localstorage";
import HtmlToPdf from "../../../components/HtmlToPdf";
import ServiceAgreementPdf from "../../../components/reportpdftemplate/serviceagreementpdf";
import "../../../components/reportpdftemplate/base.min.css";
import "../../../components/reportpdftemplate/fancy.min.css";
import "../../../components/reportpdftemplate/main.css";
import bg3 from "../../../components/reportpdftemplate/bg3.png";
import bg5 from "../../../components/reportpdftemplate/bg5.png";
import bg6 from "../../../components/reportpdftemplate/bg6.png";
import bg7 from "../../../components/reportpdftemplate/bg7.png";

import { useFormik } from "formik";
import { RadioButton } from "primereact/radiobutton";

export default function PersonalActionFormInitiator() {
  const toast = useRef(null);

  const [employee_Id, setEmployee_Id] = useState("");
  const [employeeName, setemployeeName] = useState("");
  const [positionTitle, setpositionTitle] = useState("");
  const [transferredPositionTitle, settransferredPositionTitle] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [startEndDate, setStarEndDate] = useState(null);
  const [salaryRate, setsalaryRate] = useState("");
  const [rateofPay, setrateofPay] = useState("");
  const [reason, setreason] = useState("");
  const [fundingSource, setfundingSource] = useState("");
  const [accountNo, setaccountNo] = useState("");
  const [budgetCode, setbudgetCode] = useState("");

  //states start
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [initiatorReportList, setInitiatorReportList] = useState([]);
  //states end
  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharge, setAccountCharged] = useState("");
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState("");
  let [userList, setUserList] = useState([]);
  const [subjectCode, setSubjectCodeList] = useState(null);
  const [value, setValue] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [fteUtilized, setFteUtilized] = useState("");
  const [checked, setChecked] = useState(false);
  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState("center");
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState();
  const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
  const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
  const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
  const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
  const [activate, setActivate] = useState("");
  const [attchmentAndDetailes, SetAttchmentAndDetailes] = useState(false);
  const [termsAndConditions, SetTermsAndConditions] = useState(false);
  const [eddDetailes, SetEddDetailes] = useState(false);
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);

  const [visibleNewForm, setVisibleNewForm] = useState(false);

  const [visibleconfirmationpopup, setConfirmationpopup] = useState(false);

  /////////////////

  const [Post, setPost] = useState();

  const footerContent = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible(false);
          setVisibleEdit(false);
        }}
      >
        Close
      </button>
    </div>
  );
  const footerContent1 = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible2(false);
          setShowNextPopUp(false);
          setVisibleCreteReportPopup(false);
          setShowPreviewPopUp(false);
        }}
      >
        Close
      </button>
    </div>
  );

  const footerConfirm = (
    <div>
      <Link
        to="/initiator/initiatereportlist"
        onClick={() => setConfirmationpopup(false)}
        className="w-35 mr-12 p-button-text"
      >
        Close
      </Link>
      <Link
        to={"JavaScript:void(0)"}
        className="w-35 mr-9 text-center tableBtn blue radius8"
        onClick={() => setConfirmationpopup(false)}
      >
        <i className="plusgusd-e-circle mx-1.5 "></i> Add New
      </Link>
    </div>
  );

  const header = (
    <div>
      <i className="pi pi-check-circle" style={{ color: "#32CD32" }}></i>&nbsp;
      <button style={{ color: "#326DBB" }}>Report Sent</button>
    </div>
  );

  //_____popup

  //*state
  const [reportId, setReportId] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [schoolList, setSchoolList] = useState("");
  const [schoolSelect, setSelectedSchool] = useState("");
  const [partyDetailesPopup, setPartyDetailesPopUp] = useState(false);

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get("loggedUserId");
  const [endDate, setEndDate] = useState(null);
  const [assighnmentTitle, setAssighnmentTitle] = useState("");
  const [w9Detailes, SetW9Detailes] = useState(false);
  const currentDateTime = moment();

  const TaskStatusSL = product => {
    switch (product.status) {
      case "Reviewed & resubmitted":
        return "info";

      case "Rejected":
        return "danger";

      case "Pending":
        return "warning";

      case "Submitted":
        return "info";

      case "Approved":
        return "success";

      case "Approved (P)":
        return "success";

      default:
        return null;
    }
  };

  const TaskStatusSLA = product => {
    // console.log("product", product.status);
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };

  // radio button

  const radioBtns = [
    {
      id: "certified",
      name: "certified",
      value: "Certified",
      inputId: "f1"
    },
    {
      id: "classified",
      name: "classified",
      value: "Classified",
      inputId: "f2"
    }
  ];

  const show = () => {
    toast.current.show({ severity: "success", summary: "Form Submitted", detail: formik.values.item });
  };

  const formik = useFormik({
    initialValues: {
      item: ""
    },
    validate: data => {
      let errors = {};

      if (!data.item) {
        errors.item = "Value is required.";
      }

      return errors;
    },
    onSubmit: data => {
      data.item && show();
      formik.resetForm();
    }
  });

  const isFormFieldInvalid = name => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = name => {
    return isFormFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
  // end radio button

  const alljobactionContent = row => {
    return (
      <div className="flex justify-center w-full gap-2">
        {row.status === "Submitted" ? (
          <Link to="#" className="py-2 px-2.5" onClick={() => onClickViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : row.status === "Approved" ? (
          <Link to="#" className="py-2 px-2.5" onClick={() => onClickViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : row.status === "Reviewed & resubmitted" ? (
          <Link to="#" className="py-2 px-2.5" onClick={() => onClickViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : (
          <Link to="#" className="py-2 px-2.5" onClick={() => onClickEditPopUp(row)}>
            <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
          </Link>
        )}
      </div>
    );
  };

  //* onclick view popup
  const onClickViewPopup = async (requestData, position) => {
    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized
    };
    setSpecificReportDetailsView(obj);
  };

  const onClickEditPopUp = async requestData => {
    setVisibleEdit(true);

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized
    };
    setSpecificReportDetailsEdit(obj);
  };

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) {
        userHasAuthenticated(false);
      }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  const saveBasicInfo = async type => {
    if (selectedEmployee === null) {
      toast.error("Please Select Employee Id");
      return;
    } else if (schoolSelect === "") {
      toast.error("Please Select Assignment At");
      return;
    } else if (assighnmentTitle === "") {
      toast.error("Please enter Assighment Title");
      return;
    } else if (startDate === null) {
      toast.error("Please enter From Date");
      return;
    } else if (endDate === null) {
      toast.error("Please enter To Date");
      return;
    } else if (subjectCode === null) {
      toast.error("Please enter To Date");
      return;
    }

    var updatedSchoolId;

    //Save Basic Info

    //check type
    if (type === "save") {
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(
        new SixthPeriodAssignmentInitiateReport({
          assignment_title: assighnmentTitle,
          employee_id: selectedEmployee.name,
          assighment_at: schoolSelect.name,
          from_date: moment(startDate).format("YYYY-MM-DD"),
          to_date: moment(endDate).format("YYYY-MM-DD"),
          subject_area: subjectCode.name,
          total_staffing_allocation: totalStaffingAllocationectedRole,
          account_charged: accountCharge,
          current_fte_utilized: fteUtilized,
          status: Request_Status.P
        })
      );
    } else {
      //other wise status submit
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(
        new SixthPeriodAssignmentInitiateReport({
          assignment_title: assighnmentTitle,
          employee_id: selectedEmployee.name,
          assighment_at: schoolSelect.name,
          from_date: moment(startDate).format("YYYY-MM-DD"),
          to_date: moment(endDate).format("YYYY-MM-DD"),
          subject_area: subjectCode.name,
          total_staffing_allocation: totalStaffingAllocationectedRole,
          account_charged: accountCharge,
          current_fte_utilized: fteUtilized,
          submited_by: loggedUserId,
          submited_at: moment(currentDateTime).format("YYYY-DD-MM"),
          status: Request_Status.S
        })
      );
    }

    updatedSchoolId = newSixthPeriodAssignmentInitiateReport.id;

    if (newSixthPeriodAssignmentInitiateReport) {
      toast.success("Data Added Successfully.");
      BindList();
    }
  };

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region
  });

  //*get getEmployeeResponse
  const getEmployeeResponse = id => {
    let _employeeList = [...employeeList];
    var returnRecord = _employeeList.find(o => o.id === String(id));
    if (returnRecord !== null && returnRecord !== undefined) {
      return returnRecord;
    } else {
      return null;
    }
  };

  //Get Weekly Absence Report-Classified List
  const BindList = async () => {
    //fetch all SixthPeriodAssignmentInitiateReport table data
    try {
      const sixPeriodInitiatorReportResponse = await DataStore.query(
        SixthPeriodAssignmentInitiateReport,
        Predicates.ALL,
        {
          sort: s => s.assignment_title(SortDirection.ASCENDING)
        }
      );
      if (sixPeriodInitiatorReportResponse) {
        console.log("data is bbbbbbbbbb:-", sixPeriodInitiatorReportResponse);
        //change data format according to UI.
        let submitCount = 0;
        let approvedCount = 0;
        let rejectCount = 0;
        let finalData = [];
        sixPeriodInitiatorReportResponse.map((currentItem, i) => {
          //change format of period attribute
          const startDate = new Date(currentItem.from_date);
          const endDate = new Date(currentItem.to_date);

          const dateFormatter = new Intl.DateTimeFormat("en-US", { day: "numeric", month: "short", year: "numeric" });
          const formattedStartDate = dateFormatter.format(startDate);
          const formattedEndDate = dateFormatter.format(endDate);
          const period = `${formattedStartDate} to ${formattedEndDate}`;

          let obj = {
            srNo: i + 1,
            assignmentTitle: currentItem.assignment_title,
            period: period,
            submittedOn: currentItem.submited_at,
            status: currentItem.status.charAt(0).toUpperCase() + currentItem.status.slice(1).toLowerCase(),
            // remark:currentItem.remark
            employee_id: currentItem.employee_id,
            assighment_at: currentItem.assighment_at,
            from_date: currentItem.from_date,
            to_date: currentItem.to_date,
            subject_area: currentItem.subject_area,
            total_staffing_allocation: currentItem.total_staffing_allocation,
            account_charged: currentItem.account_charged,
            current_fte_utilized: currentItem.current_fte_utilized
          };

          //specific report category get approved,submitted and rejected count

          if (currentItem.status === "SUBMITTED") {
            submitCount++;
          } else if (currentItem.status === "APPROVED") {
            approvedCount++;
          } else if (currentItem.status === "REJECTED") {
            rejectCount++;
          }
          setSubmitCount(submitCount);
          setApprovedCount(approvedCount);
          setRejectCount(rejectCount);

          finalData.push(obj);
        });

        setInitiatorReportList(finalData);
      }
    } catch (error) {
      console.log("Error for bindList", error);
    }

    var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    setSubjectCodeList(SubjectCodeResponses);
    var myArray = [];
    myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses);
    setSubjectListDropdown(myArray);

    var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = [];
    schoolArray = ConvertResponseForSelect(SchoolResponses);
    setSchoolList(schoolArray);

    var employeeList = await DataStore.query(Employee, Predicates.ALL, {
      sort: s => s.employee_name(SortDirection.ASCENDING)
    });
    setEmployeeList(employeeList);

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
      }
    });

    loadAbsenceReport();
  };

  //*loadAbsenceReport
  const loadAbsenceReport = async () => {
    //*Set Weekly Absence Report-Classified List
    var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport);
    let newResponse = [];
    for (let i = 0; i < weeklyAbsenceReport.length; i++) {
      let schoolName = "";
      let workDuration = "";
      let submittedOn = "";
      let status = "";
      let remark = "";

      //*Work Duration
      if (weeklyAbsenceReport[i].from_date && weeklyAbsenceReport[i].to_date) {
        let fromDate = moment(weeklyAbsenceReport[i].from_date, "YYYY-DD-MM").format("Do");
        let toDate = moment(weeklyAbsenceReport[i].to_date, "YYYY-DD-MM").format("Do MMMM'YY");
        workDuration = fromDate + " - " + toDate;
      } else {
        workDuration = "-";
      }

      //*submitted On
      if (weeklyAbsenceReport[i].status_date_time !== null && weeklyAbsenceReport[i].status_date_time !== undefined) {
        submittedOn =
          weeklyAbsenceReport[i].status_date_time !== null
            ? moment(weeklyAbsenceReport[i].status_date_time).format("Do MMMM'YY")
            : "-";
      } else {
        submittedOn = "-";
      }

      // //*School Name
      if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
        var schoolResponses = await DataStore.query(Schools, c => c.id.eq(weeklyAbsenceReport[i].school_id));
        if (schoolResponses.length > 0) {
          schoolName = schoolResponses[0].name;
        } else {
          schoolName = "";
        }
      } else {
        schoolName = "";
      }

      if (
        weeklyAbsenceReport[i].payroll_status !== null &&
        weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED
      ) {
        status = "Approved (P)";
        remark = "-";
      } else if (
        weeklyAbsenceReport[i].payroll_status !== null &&
        weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED
      ) {
        status = "Rejected (P)";
        remark = weeklyAbsenceReport[i].payroll_remark;
      } else if (
        weeklyAbsenceReport[i].approver_status !== null &&
        weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED
      ) {
        status = "Approved (A)";
        remark = "-";
      } else if (
        weeklyAbsenceReport[i].approver_status !== null &&
        weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_REJECTED
      ) {
        status = "Rejected (A)";
        remark = weeklyAbsenceReport[i].approver_remark;
      } else if (
        weeklyAbsenceReport[i].payroll_status === null &&
        weeklyAbsenceReport[i].approver_status === null &&
        weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.SUBMITTED
      ) {
        status = "Submitted";
        remark = "-";
      } else if (
        weeklyAbsenceReport[i].payroll_status === null &&
        weeklyAbsenceReport[i].approver_status === null &&
        weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.OPEN
      ) {
        status = "Pending";
        remark = "-";
      }

      newResponse.push({
        id: weeklyAbsenceReport[i].id,
        user_id: weeklyAbsenceReport[i].user_id,
        status: status,
        school_id: weeklyAbsenceReport[i].school_id,
        from_date: weeklyAbsenceReport[i].from_date,
        to_date: weeklyAbsenceReport[i].to_date,
        status_date_time: weeklyAbsenceReport[i].status_date_time,
        approver_remark: weeklyAbsenceReport[i].approver_remark,
        payroll_remark: weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-",
        schoolName: schoolName,
        workDuration: workDuration,
        submittedOn: submittedOn,
        remark: remark,
        createdAt: weeklyAbsenceReport[i].createdAt,
        updatedAt: weeklyAbsenceReport[i].updatedAt
      });

      if (i === weeklyAbsenceReport.length - 1) {
        setWeeklyAbsenceReports(newResponse);
        //SubmittedCount
        const submittedCount = newResponse.filter(obj => obj.status === "Submitted");
        setWeeklyAbsenceReportSubmitted(submittedCount.length);

        //SubmittedCount
        const approvedCountP = newResponse.filter(obj => obj.status === "Approved (P)");
        const approvedCountA = newResponse.filter(obj => obj.status === "Approved (A)");
        let approvedCount = approvedCountP.length + approvedCountA.length;
        setWeeklyAbsenceReportApproved(approvedCount);

        //RejectedCount
        const rejectedCountP = newResponse.filter(obj => obj.status === "Rejected (P)");
        const rejectedCountA = newResponse.filter(obj => obj.status === "Rejected (A)");
        const rejectedCount = rejectedCountP.length + rejectedCountA.length;
        setWeeklyAbsenceReportRejected(rejectedCount);

        //RejectedCount
        const pendingCount = newResponse.filter(obj => obj.status === "Pending");
        setWeeklyAbsenceReportPending(pendingCount.length);
      }
    }
  };

  // useEffect(() => {
  //   // onLoad();
  //   BindList_forPersonalActionForm();
  // }, []);

  async function BindList_forPersonalActionForm() {
    console.log("Form Submitted");
    // await DataStore.delete(PersonalActionForm, Predicates.ALL);
    const addone = await DataStore.save(
      new PersonalActionForm({
        employeeId: employee_Id,
        employeeName: employeeName,
        positionTitle: positionTitle + " - " + transferredPositionTitle,
        effectiveDates: startDate + " - " + startEndDate,
        salaryRate: salaryRate,
        rateofPay: rateofPay,
        reason: reason,
        fundingSource: fundingSource,
        accountNo: accountNo,
        budgetCode: budgetCode,
        data: "Pending"
      })
    );

    var personal = await DataStore.query(PersonalActionForm);
    console.log(personal);
    setConfirmationpopup(true);

    // var personal = await DataStore.query(PersonalActionForm, c =>
    //   c.employeeId("eq", employeeId)
    // );
    // console.log(personal);
    // await DataStore.delete(personal);

    //                     const toDelete = await DataStore.query(PersonalActionForm, '15850');
    // if (toDelete) {
    //   DataStore.delete(toDelete);
    // }

    // DataStore.delete(personal);
  }

  return isAuthenticated ? (
    <>
      <Layout pageTitle="Report" activeMenu="Initiator" appId={"PERSONNEL_ACTION_FORM"}>
        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
          <div className="flex justify-end visible lg:hidden">
            <Button
              icon="pi pi-bars"
              onClick={toggleActive}
              style={{
                color: "#308B90",
                background: "#ffffff00",
                border: "1",
                borderColor: "#308B90",
                width: "38px",
                padding: "6px 0",
                borderRadius: "4px"
              }}
            ></Button>
          </div>
          <div className="grid grid-cols-0 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
            <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
              <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]">
                <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                  <p className="text-[0.938vw]  text-[#101828] font-medium">
                    Reports Initiate New Form
                  </p>

                  <div style={{ float: "right" }}>
                    <Link to="" className="text-[#113699]  mr-5">
                      <i className="pi pi-print"></i> Print
                    </Link>

                    <Link to="" className="text-[#113699]  mr-5">
                      <i className="pi pi-upload"></i> Attachments
                    </Link>

                    <Link to="" onClick={() => setVisible(true)} className="text-[#113699] mr-5">
                      Form history
                    </Link>
                  </div>
                </div>

                <div className="initiator">
                  <div className="card flex justify-content-center">
                    <div className="col p-3">
                      <label
                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                        for="username"
                      >
                        Select One
                      </label>
                    </div>

                    <form
                      onSubmit={formik.handleSubmit}
                      className="flex justify-between text-[#101828] font-medium  tracking-[0.02em] xl:text-[0.932vw]"
                    >
                      <div className="flex p-5  mt-5">
                        <toast ref={toast} />

                        {radioBtns.map((btn, i) => {
                          return (
                            <div key={i} className="flex align-items-center mr-3 mt-5">
                              <RadioButton
                                {...btn}
                                checked={formik.values.item === btn.value}
                                onChange={e => {
                                  formik.setFieldValue("item", e.value);
                                }}
                              />
                              <label htmlFor={btn.inputId} className="ml-1">
                                {btn.value}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col p-5">
                        <label
                          className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                          for="username"
                        >
                          board meeting Date
                        </label>
                        <div className="relative custp-calender">
                          <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                          <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                          <div className="card flex justify-content-center">
                            <Calendar
                              onChange={e => {
                                setStartDate(e.target.value);
                              }}
                              value={startDate}
                              placeholder="Choose Date"
                              className="w-full h-11"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col p-5">
                        <label
                          className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                          for="username"
                        >
                          Personnel Report No
                        </label>
                        <input
                          value={totalStaffingAllocationectedRole}
                          onChange={e => setTotalStaffingAllocation(e.target.value)}
                          type="text"
                          name=""
                          class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                          placeholder="Enter The Number"
                        />
                      </div>
                      <div className="col p-5">
                        <label
                          className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                          for="username"
                        >
                          Location
                        </label>
                        <input
                          value={totalStaffingAllocationectedRole}
                          onChange={e => setTotalStaffingAllocation(e.target.value)}
                          type="text"
                          name=""
                          class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                          placeholder="Type Your location"
                        />
                      </div>
                      <div className="col p-5">
                        <label
                          className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                          for="username"
                        >
                          Action To be Taken
                        </label>
                        <input
                          value={totalStaffingAllocationectedRole}
                          onChange={e => setTotalStaffingAllocation(e.target.value)}
                          type="text"
                          name=""
                          class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                          placeholder="Type the Action"
                        />
                      </div>
                      {getFormErrorMessage("item")}
                    </form>
                  </div>

                  <center>
                    <img src="/clock.jpg" />

                    <div className="p-5">
                      <strong>You haven't added any board yet</strong>
                    </div>

                    <div className=" items-center gap-3 xl:gap-[1.250vw] pb-5" style={{ width: "10vw" }}>
                      <Link
                        to={"JavaScript:void(0)"}
                        className="w-full text-center tableBtn blue radius8"
                        onClick={() => setVisibleNewForm(true)}
                      >
                        <i className="gusd-pluse-circle mx-1.5 "></i> Add New
                      </Link>
                    </div>
                  </center>
                </div>

                <Dialog
                  className="relative reports-popup"
                  visible={visible}
                  position={position}
                  style={{ width: "80vw" }}
                  breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                  onHide={() => setVisible(false)}
                  draggable={false}
                  resizable={false}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-12">
                    <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                      <div className="p-5">
                        <div onClick={() => setVisible(false)} className="py-3">
                          <Image src={sideBarRight} alt="user" width="24" height="24" />
                        </div>

                        {!fullViewForView ? (
                          <div className="">
                            <div className="text-center">
                              <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">
                                GLENDALE UNIFIED SCHOOL DISTRICT
                              </div>
                              <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">
                                Request For Approval - Sixth Period Teaching Assignment
                              </div>
                            </div>

                            <div className="pt-3">
                              <p>Approval Status</p>
                              <div className="py-3 emp-simple-tbl">
                                <DataTable
                                  value={[
                                    {
                                      id: "1000",
                                      title: "Principal",
                                      name: "Alrick Barwa",
                                      status: "Approved"
                                    },
                                    {
                                      id: "1001",
                                      title: "Teacher",
                                      name: "John Mishra",
                                      status: "Approved"
                                    },
                                    {
                                      id: "1002",
                                      title: "EAFE Program Administrator",
                                      name: "Alrick Barwa",
                                      status: "Approved"
                                    }
                                  ]}
                                >
                                  <Column field="title" header="Title"></Column>
                                  <Column field="name" header="Name"></Column>
                                  <Column field="status" header="Status"></Column>
                                </DataTable>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                          <div className="flex justify-between">
                            <div className="text-[#344054] font-medium text-[20px] pb-3">
                              <i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf
                            </div>
                            <button
                              onClick={() => {
                                !fullViewForView ? setFullViewForView(true) : setFullViewForView(false);
                              }}
                              className="text-[#113699] font-medium text-[14px] pb-3"
                            >
                              <i className="pi pi-calendar mr-1 mt-2"></i>
                              {!fullViewForView ? "View Full Screen" : "Exit Full Screen"}{" "}
                            </button>
                          </div>

                          <div className="grid grid-cols-1">
                            {/* <img src={pdfImage} alt='myImg' /> */}
                            {/* <HtmlToPdf
                              data={{
                                'employeeName': 'Abc',
                                'employeeId': selectedEmployee.name,
                                'schoolName': schoolSelect.name,
                                'dateFrom': moment(startDate).format("YYYY-DD-MM"),
                                'dateTo': moment(endDate).format("YYYY-DD-MM"),
                                'subjectName': subjectCode.name,
                                'staffAllocation': totalStaffingAllocationectedRole,
                                'accountCharged': accountCharge,
                                'fteUtilized': fteUtilized
                              }}
                            /> */}
                            <HtmlToPdf
                              data={{
                                employeeName: "Abc",
                                employeeId: specificReportDetailsView.employee_id,
                                schoolName: specificReportDetailsView.assighment_at,
                                dateFrom: specificReportDetailsView.from_date,
                                dateTo: specificReportDetailsView.to_date,
                                subjectName: specificReportDetailsView.subject_area,
                                staffAllocation: specificReportDetailsView.total_staffing_allocation,
                                accountCharged: specificReportDetailsView.account_charged,
                                fteUtilized: specificReportDetailsView.current_fte_utilized
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                            <i className="mr-3 gusd-print-outline"></i>
                            <span>Print</span>
                          </div>

                          <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                            <i className="mr-3 gusd-print-outline"></i>
                            <span>Download</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                      <div className="p-5">
                        <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                            Yesterday
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src={user1} alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhon Paul</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                changed the input name of employee from “Kalvin” to “Samston”.
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src={user2} alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhoana Maria</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                changed the input name of employee from “Kalvin” to “Samston”.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                            April 7h
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user3.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jennifer Lopez</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                changed the input name of employee from “Kalvin” to “Samston”.
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user4.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Lethicia Jhansen</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                changed the input name of employee from “Kalvin” to “Samston”.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                            April 7h
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user5.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhon Doe</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                changed the input name of employee from “Kalvin” to “Samston”.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog>

                {/* edit popup start */}
                <Dialog
                  className="relative reports-popup"
                  visible={visibleEdit}
                  position="right"
                  style={{ width: `${fullViewEdit ? "50vw" : "30vw"}` }}
                  breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                  onHide={() => setVisibleEdit(false)}
                  draggable={false}
                  resizable={false}
                >
                  <div className="">
                    <div className="bg-[#F5F6F7] relative h-screen">
                      <div className="p-5">
                        <a to="" onClick={() => setVisibleEdit(false)} className="py-3">
                          <Image src={sidebar} alt="user" width="24" height="24" />
                        </a>

                        {!fullViewEdit ? (
                          <div>
                            <div className="text-[#113699] text-[0.833vw] font-bold">
                              Personal Service Agreement
                            </div>
                            <div className="text-[#344054] text-[0.625vw] font-medium">
                              Sixth Period Teaching Assignment - Classified form
                            </div>
                            <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                              <div className="mb-1">
                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">
                                  Approval Status
                                </label>
                                <div className="py-3 emp-simple-tbl">
                                  <DataTable
                                    value={[
                                      {
                                        id: "1000",
                                        title: "Principal",
                                        name: "Alrick Barwa",
                                        status: "Approved"
                                      },
                                      {
                                        id: "1001",
                                        title: "Teacher",
                                        name: "John Mishra",
                                        status: "Approved"
                                      },
                                      {
                                        id: "1002",
                                        title: "EAFE Program Administrator",
                                        name: "Alrick Barwa",
                                        status: "Approved"
                                      }
                                    ]}
                                  >
                                    <Column field="title" header="Title"></Column>
                                    <Column field="name" header="Name"></Column>
                                    <Column field="status" header="Status"></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                          {!fullViewEdit ? (
                            <div className="flex justify-between">
                              <div className="text-[#344054] font-medium text-[20px] pb-3">
                                <i className="mr-3 gusd-document"></i>Sixth Period.pdf
                              </div>
                              <button
                                onClick={() => setFullViewEdit(true)}
                                className="text-[#113699] font-medium text-[14px] pb-3"
                              >
                                <i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen
                              </button>
                            </div>
                          ) : (
                            <div className="flex justify-between">
                              <div className="text-[#344054] font-medium text-[20px] pb-3">
                                <i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf
                              </div>
                              <button
                                onClick={() => setFullViewEdit(false)}
                                className="text-[#113699] font-medium text-[14px] pb-3"
                              >
                                <i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen
                              </button>
                            </div>
                          )}

                          {!fullViewEdit ? (
                            <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                              {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                              <HtmlToPdf
                                data={{
                                  employeeName: "Abc",
                                  employeeId: specificReportDetailsEdit.employee_id,
                                  schoolName: specificReportDetailsEdit.assighment_at,
                                  dateFrom: specificReportDetailsEdit.from_date,
                                  dateTo: specificReportDetailsEdit.to_date,
                                  subjectName: specificReportDetailsEdit.subject_area,
                                  staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                  accountCharged: specificReportDetailsEdit.account_charged,
                                  fteUtilized: specificReportDetailsEdit.current_fte_utilized
                                }}
                              />
                            </div>
                          ) : (
                            <div
                              className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto"
                              style={{ height: "580px" }}
                            >
                              {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                              <HtmlToPdf
                                data={{
                                  employeeName: "Abc",
                                  employeeId: specificReportDetailsEdit.employee_id,
                                  schoolName: specificReportDetailsEdit.assighment_at,
                                  dateFrom: specificReportDetailsEdit.from_date,
                                  dateTo: specificReportDetailsEdit.to_date,
                                  subjectName: specificReportDetailsEdit.subject_area,
                                  staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                  accountCharged: specificReportDetailsEdit.account_charged,
                                  fteUtilized: specificReportDetailsEdit.current_fte_utilized
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">
                        <Link
                          to="#"
                          className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                          //  onClick={() => setVisibleCreteReportPopup(false)}
                          onClick={() => setConfirmVisible(true)}
                        >
                          <i className="pi pi-save mr-1" style={{ fontSize: "1rem" }}></i>Save
                        </Link>

                        <Link
                          to=""
                          className=" text-center flex items-center tableBtn blue radius8"
                          //  onClick={() => saveGroupInfo()}
                          onClick={() => setConfirmVisible(true)}
                        >
                          <i className="pi pi-check mr-1" style={{ fontSize: "1rem" }}></i>Submit
                        </Link>
                      </div>
                    </div>
                  </div>
                </Dialog>

                {/* confirmation dialog */}

                <Dialog
                  header=""
                  visible={confirmVisible}
                  style={{ width: "30vw" }}
                  onHide={() => {
                    setConfirmVisible(false);
                    setVisibleEdit(false);
                  }}
                  footer={footerContent}
                >
                  <p className="m-0 text-[#0487C8]">
                    <i className="pi pi-check-circle mr-2"></i>
                    <span className="font-medium text-[18px]">Your changes has been saved in this report</span>
                  </p>
                </Dialog>
                {/* edit popup end */}
              </div>

              <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
                style={{ width: "35vw" }}
                className="customesidebar1 responsivepoup"
              >
                <Editpopup
                  popupstate={() => setVisibleRight(false)}
                  fromDate={fromDate}
                  toDate={toDate}
                  schoolName={schoolName}
                  reportEmployeeList={reportEmployeeList}
                  status={status}
                  reportId={reportId}
                  bindList={() => loadAbsenceReport()}
                  type={"Initior"}
                />
              </Sidebar>
            </div>
          </div>
        </div>

        {/* popup's */}
        <Dialog
          className="relative reports-popup"
          visible={visibleCreteReportPopup}
          position="right"
          style={{ width: "30vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          onHide={() => setVisibleCreteReportPopup(false)}
          draggable={false}
          resizable={false}
        >
          <div className="">
            <div className="bg-[#F5F6F7] relative h-screen">
              <div className="p-5">
                <a to="" onClick={() => setVisibleCreteReportPopup(false)} className="py-3">
                  <Image src={sidebar} alt="user" width="24" height="24" />
                </a>
                <div className="text-[#113699] text-[0.833vw] font-bold">Initiate New Form</div>
                {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                  <div className="mb-1">
                    <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">
                      Assignment Title
                    </label>
                    <div>
                      <InputText
                        value={groupName}
                        onChange={e => setGroupName(e.target.value)}
                        id="username"
                        placeholder="Type Here"
                        className="w-full placeholder:text-[#667085] "
                        aria-describedby="username-help"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">
                <Link
                  to="#"
                  className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                  onClick={() => setVisibleCreteReportPopup(false)}
                >
                  <i className="pi pi-times mr-1" style={{ fontSize: "1rem" }}></i>Cancel
                </Link>

                <Link
                  to=""
                  className=" text-center flex items-center tableBtn blue radius8"
                  onClick={() => {
                    setShowNextPopUp(true);
                    // saveGroupInfo();
                  }}
                >
                  <i className="pi pi-arrow-right mr-1" style={{ fontSize: "1rem" }}></i>Next
                </Link>
              </div>
            </div>
          </div>
        </Dialog>

        {/* next full popup */}
        <Dialog
          className="relative reports-popup"
          visible={showNextPopUp}
          position="right"
          style={{ width: "100vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          onHide={() => setShowNextPopUp(false)}
          draggable={false}
          resizable={false}
        >
          {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
          <div className="fixed z-10 inset-0 overflow-y-auto styled-select">
            <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
              <div className="relative overflow-hidden transform transition-all w-full">
                <div className="grid grid-cols-12 custmCols">
                  <div className="col-span-3 h-full sideBarLeft openSideDiv">
                    <button
                      onClick={() => {
                        setShowPreviewPopUp(false);
                        setShowNextPopUp(false);
                      }}
                      type="button"
                      className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                      id="add-family-cancel-btn"
                    >
                      <i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home
                    </button>
                    <div className="mt-[16px] xl:mt-[0.833vw] text-[#101828] text-[14px] xl:text-[0.633vw] font-normal">
                      GUSD Personal Action Form
                    </div>
                    <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">
                      Assignment 10102
                    </div>
                    <div className="mt-[32px] xl:[1.667vw]">
                      <ul className="sideTabs">
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setShowPreviewPopUp(false);
                              SetBasicInfoPopUp(true);
                              setPartyDetailesPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                            }}
                            className={`${basicInfoPopUp === true ? "tab-b active activeCheck" : ""}`}
                            data-id="tab1"
                          >
                            <i className="gusd-guardian-info text-[1.042vw]"></i>
                            Basic Info
                          </a>
                        </li>

                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setPartyDetailesPopUp(true);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                            }}
                            className={`${partyDetailesPopup === true ? "tab-b active activeCheck" : null}`}
                            class="tab-b"
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>PSA Consultant Details
                          </a>
                        </li>

                        <li>
                          <a
                            href="javascript:void(0);"
                            onClick={() => {
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(true);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                            }}
                            className={`${attchmentAndDetailes === true ? "tab-b active activeCheck" : null}`}
                            class="tab-b"
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>Attachments & Notes
                          </a>
                        </li>

                        <li>
                          <a
                            href="javascript:void(0);"
                            onClick={() => {
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(true);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                            }}
                            className={`${termsAndConditions === true ? "tab-b active activeCheck" : null}`}
                            class="tab-b"
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>Terms & Conditions
                          </a>
                        </li>

                        <li>
                          <a
                            href="javascript:void(0);"
                            onClick={() => {
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(true);
                              SetPreviewAndEdit(false);
                            }}
                            className={`${eddDetailes === true ? "tab-b active activeCheck" : null}`}
                            class="tab-b"
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>EDD Details
                          </a>
                        </li>

                        <li>
                          <a
                            href="javascript:void(0);"
                            onClick={() => {
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(true);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                            }}
                            class="tab-b"
                            className={`${w9Detailes === true ? "tab-b active activeCheck" : null}`}
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>W9 Details
                          </a>
                        </li>

                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(true);
                            }}
                            className={`${previewAndEdit === true ? "tab-b active activeCheck" : null}`}
                            data-id="tab2"
                          >
                            <i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="fixed top-0 left-0 openBtn xl:hidden">
                      <button
                        type="button"
                        className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"
                      >
                        <i className="gusd-arrow-line-right"></i>
                      </button>
                    </div>
                  </div>

                  <div
                    className="col-span-12 xl:col-span-6 
                  mScrollCstm 
                  overflow-auto 
                  "
                  >
                    <div className="tab-c tab-active p-lr-110 pt-10 xl:pt-0 " data-id="tab1">
                      {basicInfoPopUp === true ? (
                        <div>
                          <div className="text-[1.250vw] font-medium">Basic Info</div>
                          <div className="mCustomScrollbar scroll-w-10 max-h-100">
                            <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] ">
                              <form>
                                <div className=" grid grid-cols-2 gap-8">
                                  <div className="">
                                    <div className="col ">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Department<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <Dropdown
                                        value={selectedEmployee}
                                        onChange={e => {
                                          setSelectedEmployee(e.value);
                                          //set selected id employee data
                                          allEmployeeDetails.map(currentItem => {
                                            if (currentItem.id === e.value.code) {
                                              setSelectedEmployeeDetails(currentItem);
                                            }
                                          });
                                        }}
                                        options={empCodeList}
                                        optionLabel="name"
                                        placeholder="Select a Employee"
                                        filter
                                        // valueTemplate={selectedCountryTemplate}
                                        className="w-full md:w-14rem"
                                      />
                                    </div>

                                    <div className="col ">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Amount<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <input
                                        onChange={e => setAssighnmentTitle(e.target.value)}
                                        type="text"
                                        name=""
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>

                                    <div className="col mt-1.5">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Expiration Date<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={e => {
                                              setStartDate(e.target.value);
                                            }}
                                            value={startDate}
                                            placeholder="Start Date"
                                            className="w-full h-11"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Notify Days<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="">
                                        <div className="relative custp-calender">
                                          <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                          <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                          <div className="card flex justify-content-center">
                                            <Calendar
                                              onChange={e => {
                                                setStartDate(e.target.value);
                                              }}
                                              value={startDate}
                                              placeholder="Start Date"
                                              className="w-full h-11"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Account No.<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <input
                                        onChange={e => setAssighnmentTitle(e.target.value)}
                                        type="text"
                                        name=""
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>

                                    <div className="col mt-1">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Board Item
                                      </label>
                                      <input
                                        value={totalStaffingAllocationectedRole}
                                        onChange={e => setTotalStaffingAllocation(e.target.value)}
                                        type="text"
                                        name=""
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Services
                                      </label>
                                      <input
                                        value={fteUtilized}
                                        onChange={e => setFteUtilized(e.target.value)}
                                        name=""
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>
                                  </div>

                                  <div className="">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Agreement Date<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <div className="relative custp-calender">
                                      <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                      <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                      <div className="card flex justify-content-center">
                                        <Calendar
                                          onChange={e => {
                                            setStartDate(e.target.value);
                                          }}
                                          value={startDate}
                                          placeholder="Start Date"
                                          className="w-full h-11"
                                        />
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Effective Date<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={e => {
                                              setStartDate(e.target.value);
                                            }}
                                            value={startDate}
                                            placeholder="Start Date"
                                            className="w-full h-11"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Review Date<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={e => {
                                              setStartDate(e.target.value);
                                            }}
                                            value={startDate}
                                            placeholder="Start Date"
                                            className="w-full h-11"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Submitted to<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="">
                                        <Dropdown
                                          value={selectedEmployee}
                                          onChange={e => {
                                            setSelectedEmployee(e.value);
                                            //set selected id employee data
                                            allEmployeeDetails.map(currentItem => {
                                              if (currentItem.id === e.value.code) {
                                                setSelectedEmployeeDetails(currentItem);
                                              }
                                            });
                                          }}
                                          options={empCodeList}
                                          optionLabel="name"
                                          placeholder="Select a Employee"
                                          filter
                                          // valueTemplate={selectedCountryTemplate}
                                          className="w-full md:w-14rem"
                                        />
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Date of board meeting<span className="text-[red] pl-0.2">*</span>
                                      </label>
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={e => {
                                              setStartDate(e.target.value);
                                            }}
                                            value={startDate}
                                            placeholder="Start Date"
                                            className="w-full h-11"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col">
                                      <label
                                        className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                        for="username"
                                      >
                                        Page/ Item
                                      </label>
                                      <input
                                        value={fteUtilized}
                                        onChange={e => setFteUtilized(e.target.value)}
                                        name=""
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                            <div>
                              <a
                                href="#"
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                onClick={() => {
                                  saveBasicInfo("save");
                                  setShowPreviewPopUp(false);
                                  setShowNextPopUp(false);
                                }}
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    saveBasicInfo();
                                    setConfirmVisible2(true);
                                    // setShowPreviewPopUp(true)
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(true);
                                    SetAttchmentAndDetailes(false);
                                    SetTermsAndConditions(false);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {partyDetailesPopup === true ? (
                        <div className="mt-[5px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                          <div className="text-[24px] xl:text-[1.250vw] font-medium">PSA Consultant Details</div>
                          <form>
                            <div className=" grid grid-cols-2 gap-8">
                              <div className="">
                                <div className="col ">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    PSA Consultant's Name<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>

                                <div className="col ">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    POC Name<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>

                                <div className="col mt-1.5">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Email<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>

                                <div className="col">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Employer Identification<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>
                              </div>

                              <div className="">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Client ID<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <input
                                  onChange={e => setAssighnmentTitle(e.target.value)}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                />

                                <div className="col">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    POC Contact Number<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>

                                <div className="col">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Social Security Number<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>
                              </div>
                            </div>
                          </form>
                          <div className="mt-4">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Type of Business Entity<span className="text-[red] pl-0.2">*</span>
                            </label>
                            <div className="flex gap-4">
                              <div className="flex">
                                <input type="radio" id="html" name="fav_language" value="HTML" />
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                  for="username"
                                >
                                  Individual
                                </label>
                              </div>
                              <div className="flex">
                                <input type="radio" id="html" name="fav_language" value="HTML" />
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                  for="username"
                                >
                                  Sole Partnership
                                </label>
                              </div>
                              <div className="flex">
                                <input type="radio" id="html" name="fav_language" value="HTML" />
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                  for="username"
                                >
                                  Partnership
                                </label>
                              </div>
                              <div className="flex">
                                <input type="radio" id="html" name="fav_language" value="HTML" />
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                  for="username"
                                >
                                  Corporation
                                </label>
                              </div>
                              <div className="flex">
                                <input type="radio" id="html" name="fav_language" value="HTML" />
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                  for="username"
                                >
                                  Others
                                </label>
                              </div>
                              <div>
                                <input
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                  placeholder="Type here"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 grid grid-cols-2 gap-8">
                            <div className="col">
                              <label
                                className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                for="username"
                              >
                                POC Contact Number<span className="text-[red] pl-0.2">*</span>
                              </label>
                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                placeholder="Type here"
                              />
                            </div>

                            <div className="col">
                              <label
                                className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                for="username"
                              >
                                POC Contact Number<span className="text-[red] pl-0.2">*</span>
                              </label>
                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                placeholder="Type here"
                              />
                            </div>
                          </div>

                          <label
                            className="text-[#344054] text-[14px] mt-4 xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                            for="username"
                          >
                            Address
                          </label>
                          <div className="flex gap-3">
                            <input
                              type="text"
                              name=""
                              class="py-[6px] text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                              placeholder="State"
                            />

                            <input
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                              placeholder="City"
                            />

                            <input
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                              placeholder="Street Address"
                            />

                            <input
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                              placeholder="Postal Code"
                            />
                          </div>

                          <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(true);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                // onClick={() => {
                                //   setShowNextPopUp(false);
                                // }}
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    // saveBasicInfo();
                                    // setConfirmVisible2(true)
                                    // setShowPreviewPopUp(true)
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(true);
                                    SetTermsAndConditions(false);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {attchmentAndDetailes === true ? (
                        <div className="h-[41vw] relative">
                          <div className="text-[24px]  xl:text-[1.250vw] font-medium">Attachments & Notes</div>
                          <label
                            className="text-[#344054] text-[14px] mt-4 xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                            for="username"
                          >
                            Type of Business Entity
                          </label>
                          <div className="flex gap-4">
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Individual
                              </label>
                            </div>
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Sole Partnership
                              </label>
                            </div>
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Partnership
                              </label>
                            </div>
                            <div>
                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Type here"
                              />
                            </div>
                          </div>
                          <div className="flex gap-2 mt-6">
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1  text-[11px] font-medium  inline-block"
                                for="username"
                              >
                                Addendum Containing Specific Terms and Condictions
                              </label>
                            </div>
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1 text-[11px] font-medium  inline-block"
                                for="username"
                              >
                                Attached Addendum Number
                              </label>
                            </div>

                            <div>
                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Type here"
                              />
                            </div>
                          </div>

                          <div className="col mt-6">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Notes<span className="text-[red] pl-0.2">*</span>
                            </label>
                            <input
                              onChange={e => setAssighnmentTitle(e.target.value)}
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                              placeholder="Types Services"
                            />
                          </div>

                          <div className="col mt-6">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Other Remarks<span className="text-[red] pl-0.2">*</span>
                            </label>
                            <input
                              onChange={e => setAssighnmentTitle(e.target.value)}
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                              placeholder="Types Services"
                            />
                          </div>

                          <div className="absolute bottom-0 right-0 left-0 grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(true);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    saveBasicInfo();
                                    setConfirmVisible2(true);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(false);
                                    SetTermsAndConditions(true);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {termsAndConditions === true ? (
                        <div className="relative h-full">
                          <div className="card termsandcondition psascroll">
                            <TabView>
                              <TabPanel header="Terms & Conditions">
                                <div>
                                  <div id="pf3" class="pf w0 h0" data-page-no="3">
                                    <div class="pc pc3 w0 h0">
                                      <img class="bi x12 y53 w11 h16" alt="" src={bg3} />
                                      <div class="t m0 x29 hd y54 ff1 fs1 fc0 sc0 ls0 ws0">
                                        GENERAL TERMS AND CONDITIONS
                                      </div>
                                      <div class="t m0 x0 h17 y55 ff2 fs7 fc0 sc0 ls0 ws0">
                                        l. <span class="_ _2"></span>
                                        <span class="ff1">
                                          PROPOSAL <span class="_ _2"></span>ACCEPTANCE. <span class="_ _4"></span>
                                        </span>
                                        Proposals <span class="_ _2"></span>are <span class="_ _2"></span>subject{" "}
                                        <span class="_ _4"></span>to <span class="_ _2"></span>acceptance
                                        <span class="_ _2"></span>by <span class="_ _4"></span>the{" "}
                                        <span class="_ _2"></span>signing <span class="_ _2"></span>of{" "}
                                        <span class="_ _4"></span>a <span class="_ _2"></span>contract{" "}
                                        <span class="_ _2"></span>and <span class="_ _4"></span>issuance{" "}
                                        <span class="_ _2"></span>of <span class="_ _2"></span>an{" "}
                                        <span class="_ _4"></span>appropriate <span class="_ _2"></span>purchase
                                        <span class="_ _2"></span>order <span class="_ _2"></span>at{" "}
                                        <span class="_ _4"></span>any <span class="_ _2"></span>time{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y56 ff2 fs7 fc0 sc0 ls0 ws0">
                                        within <span class="_ _2"></span>sixty <span class="_ _2"></span>(60){" "}
                                        <span class="_ _2"></span>days after <span class="_ _2"></span>the
                                        <span class="_ _2"></span>receipt <span class="_ _2"></span>of{" "}
                                        <span class="_ _2"></span>quotes
                                        <span class="_ _2"></span>unless <span class="_ _2"></span>otherwise{" "}
                                        <span class="_ _2"></span>stipulated. <span class="_ _2"></span>The{" "}
                                        <span class="_ _2"></span>District
                                        <span class="_ _2"></span>reserves <span class="_ _2"></span>the{" "}
                                        <span class="_ _2"></span>right
                                        <span class="_ _2"></span>to <span class="_ _2"></span>accept{" "}
                                        <span class="_ _2"></span>or <span class="_ _2"></span>reject{" "}
                                        <span class="_ _2"></span>any <span class="_ _2"></span>and all{" "}
                                        <span class="_ _2"></span>quotes <span class="_ _2"></span>and{" "}
                                        <span class="_ _2"></span>reserves
                                      </div>
                                      <div class="t m0 x0 h17 y57 ff2 fs7 fc0 sc0 ls0 ws0">
                                        the right to waive any informality in any quote.
                                      </div>
                                      <div class="t m1 x0 h17 y58 ff2 fs7 fc0 sc0 ls0 ws0">2.</div>
                                      <div class="t m0 x16 h17 y58 ff1 fs7 fc0 sc0 ls0 ws0">
                                        EQUIPMENT AND <span class="_ _2"></span>LABOR.
                                        <span class="ff2">
                                          The <span class="_ _2"></span>Provider <span class="_ _2"></span>shall furnish
                                          <span class="_ _2"></span>all tools, <span class="_ _2"></span>equipment,{" "}
                                          <span class="_ _2"></span>apparatus, facilities, <span class="_ _2"></span>
                                          transportation, labor,
                                          <span class="_ _2"></span>and material <span class="_ _2"></span>necessary{" "}
                                          <span class="_ _2"></span>to furnish{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y59 ff2 fs7 fc0 sc0 ls0 ws0">
                                        the <span class="_ _4"></span>professional <span class="_ _4"></span>services{" "}
                                        <span class="_ _4"></span>herein <span class="_ _4"></span>described,{" "}
                                        <span class="_ _4"></span>the <span class="_ _4"></span>services
                                        <span class="_ _4"></span>to <span class="_ _4"></span>be{" "}
                                        <span class="_ _2"></span>performed <span class="_ _4"></span>at{" "}
                                        <span class="_ _4"></span>such <span class="_ _4"></span>time{" "}
                                        <span class="_ _4"></span>and <span class="_ _4"></span>places{" "}
                                        <span class="_ _4"></span>as <span class="_ _4"></span>directed{" "}
                                        <span class="_ _4"></span>by <span class="_ _4"></span>and{" "}
                                        <span class="_ _4"></span>subject <span class="_ _4"></span>to{" "}
                                        <span class="_ _4"></span>the <span class="_ _4"></span>approval{" "}
                                        <span class="_ _4"></span>of <span class="_ _4"></span>the{" "}
                                        <span class="_ _4"></span>authorized{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y5a ff2 fs7 fc0 sc0 ls0 ws0">
                                        district representative indicated in the work specifications attached{" "}
                                        <span class="_ _5"> </span>hereto.
                                      </div>
                                      <div class="t m1 x0 h17 y5b ff2 fs7 fc0 sc0 ls0 ws0">3.</div>
                                      <div class="t m0 x16 h17 y5b ff1 fs7 fc0 sc0 ls0 ws0">
                                        SAFETY <span class="_ _b"> </span>AND <span class="_ _5"> </span>SECURITY.{" "}
                                        <span class="_ _b"> </span>
                                        <span class="ff2">
                                          It <span class="_ _5"> </span>shall <span class="_ _b"></span>be{" "}
                                          <span class="_ _b"> </span>the <span class="_ _5"> </span>responsibility{" "}
                                          <span class="_ _b"></span>of <span class="_ _b"></span>the{" "}
                                          <span class="_ _5"> </span>Provider <span class="_ _b"> </span>to{" "}
                                          <span class="_ _b"></span>asceuain <span class="_ _5"> </span>from{" "}
                                          <span class="_ _b"> </span>the <span class="_ _5"> </span>District{" "}
                                          <span class="_ _b"></span>the <span class="_ _b"> </span>rules
                                          <span class="_ _5"> </span>and <span class="_ _b"></span>regulations{" "}
                                          <span class="_ _b"></span>pertaining <span class="_ _5"> </span>to{" "}
                                          <span class="_ _b"> </span>safety,{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y5c ff2 fs7 fc0 sc0 ls0 ws0">
                                        security and driving on school grounds, pauicularly when children{" "}
                                        <span class="_ _2"></span>are present.
                                      </div>
                                      <div class="t m1 x0 h17 y5d ff2 fs7 fc0 sc0 ls0 ws0">4.</div>
                                      <div class="t m0 x16 h17 y5d ff1 fs7 fc0 sc0 ls0 ws0">
                                        TERMINATION.{" "}
                                        <span class="ff2">
                                          This Contract may be terminated at any time by either pany with five (5)
                                          business days&apos; advance written <span class="_ _5"> </span>notice.
                                        </span>
                                      </div>
                                      <div class="t m1 x0 h17 y5e ff2 fs7 fc0 sc0 ls0 ws0">5.</div>
                                      <div class="t m0 x2a h17 y5e ff1 fs7 fc0 sc0 ls0 ws0">
                                        DEFAULT BY <span class="_ _2"></span>PROVIDER.
                                        <span class="_ _2"></span>
                                        <span class="ff2">
                                          When <span class="_ _2"></span>Provider shall <span class="_ _2"></span>{" "}
                                          <span class="_ _2"></span>fail <span class="_ _2"></span>to deliver
                                          <span class="_ _2"></span>any <span class="_ _2"></span>article{" "}
                                          <span class="_ _2"></span>or
                                          <span class="_ _2"></span>service <span class="_ _2"></span> or{" "}
                                          <span class="_ _2"></span>shall
                                          <span class="_ _2"></span> <span class="_ _2"></span>deliver{" "}
                                          <span class="_ _2"></span>any <span class="_ _2"></span>auicle{" "}
                                          <span class="_ _2"></span>or <span class="_ _2"></span>service
                                          <span class="_ _2"></span>which does <span class="_ _2"></span>{" "}
                                          <span class="_ _2"></span>not
                                          <span class="_ _2"></span> conform{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y5f ff2 fs7 fc0 sc0 ls0 ws0">
                                        to <span class="_ _2"></span>the <span class="_ _2"></span>work{" "}
                                        <span class="_ _2"></span>specifications, <span class="_ _2"></span>the
                                        <span class="_ _2"></span>District <span class="_ _2"></span>may,{" "}
                                        <span class="_ _2"></span>upon
                                        <span class="_ _4"></span>five <span class="_ _2"></span>(5){" "}
                                        <span class="_ _2"></span>business
                                        <span class="_ _2"></span>days&apos; <span class="_ _2"></span>prior{" "}
                                        <span class="_ _2"></span>written <span class="_ _2"></span>notice{" "}
                                        <span class="_ _2"></span>describing <span class="_ _4"></span>the{" "}
                                        <span class="_ _2"></span>fault
                                        <span class="_ _2"></span>at <span class="_ _2"></span>in{" "}
                                        <span class="_ _2"></span>option, <span class="_ _2"></span>annul{" "}
                                        <span class="_ _2"></span>and <span class="_ _2"></span>set{" "}
                                        <span class="_ _4"></span>aside <span class="_ _2"></span>the{" "}
                                        <span class="_ _2"></span>contract
                                      </div>
                                      <div class="t m0 x0 h17 y60 ff2 fs7 fc0 sc0 ls0 ws0">
                                        entered <span class="_ _2"></span>into <span class="_ _2"></span>with{" "}
                                        <span class="_ _2"></span>said <span class="_ _2"></span>Provider{" "}
                                        <span class="_ _4"></span>and <span class="_ _2"></span>make{" "}
                                        <span class="_ _2"></span>and <span class="_ _2"></span>enter{" "}
                                        <span class="_ _2"></span>into <span class="_ _2"></span>a{" "}
                                        <span class="_ _4"></span>new <span class="_ _2"></span>contract{" "}
                                        <span class="_ _2"></span>in <span class="_ _2"></span>such{" "}
                                        <span class="_ _2"></span>manner <span class="_ _2"></span>as{" "}
                                        <span class="_ _4"></span>seems <span class="_ _2"></span>to{" "}
                                        <span class="_ _2"></span>the <span class="_ _2"></span>Board{" "}
                                        <span class="_ _2"></span>of <span class="_ _2"></span>Education{" "}
                                        <span class="_ _2"></span>to <span class="_ _4"></span>be{" "}
                                        <span class="_ _2"></span>to <span class="_ _2"></span>the{" "}
                                        <span class="_ _2"></span>best <span class="_ _2"></span>advantage{" "}
                                        <span class="_ _2"></span>of <span class="_ _4"></span>the{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y61 ff2 fs7 fc0 sc0 ls0 ws0">
                                        District. Any failure <span class="_ _2"></span>for furnishing{" "}
                                        <span class="_ _2"></span>such articles or <span class="_ _2"></span>services by{" "}
                                        <span class="_ _2"></span>reason of the <span class="_ _2"></span>failure of{" "}
                                        <span class="_ _2"></span>the Provider as <span class="_ _2"></span>above
                                        stated, <span class="_ _2"></span>shall be a <span class="_ _2"></span>liability
                                        against the <span class="_ _2"></span>Provider and{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y62 ff2 fs7 fc0 sc0 ls0 ws0">
                                        his <span class="_ _4"></span>sureties. <span class="_ _4"></span>The{" "}
                                        <span class="_ _b"></span>Board <span class="_ _4"></span>of{" "}
                                        <span class="_ _4"></span>Education <span class="_ _4"></span>reserves{" "}
                                        <span class="_ _b"></span>the
                                        <span class="_ _4"></span>right <span class="_ _4"></span>to{" "}
                                        <span class="_ _4"></span>cancel <span class="_ _4"></span>any{" "}
                                        <span class="_ _b"></span>articles <span class="_ _4"></span>or{" "}
                                        <span class="_ _4"></span>services <span class="_ _4"></span>which{" "}
                                        <span class="_ _b"></span>the <span class="_ _4"></span>Provider{" "}
                                        <span class="_ _4"></span>may <span class="_ _4"></span>be{" "}
                                        <span class="_ _b"></span>unable <span class="_ _4"></span>to{" "}
                                        <span class="_ _4"></span>furnish <span class="_ _4"></span>because{" "}
                                        <span class="_ _b"></span>of <span class="_ _4"></span>economic
                                      </div>
                                      <div class="t m0 x0 h17 y63 ff2 fs7 fc0 sc0 ls0 ws0">
                                        conditions, <span class="_ _1"></span>governmental
                                        <span class="_ _2"></span>regulations or <span class="_ _7"></span>other{" "}
                                        <span class="_ _8"></span>similar <span class="_ _1"></span>causes{" "}
                                        <span class="_ _1"></span>beyond the <span class="_ _8"></span>control{" "}
                                        <span class="_ _1"></span>of <span class="_ _1"></span>the
                                        <span class="_ _8"></span>Provider <span class="_ _1"></span>provided
                                        satisfactory <span class="_ _8"></span>proof <span class="_ _8"></span>is{" "}
                                        <span class="_ _7"></span>furnished to
                                        <span class="_ _7"></span>the <span class="_ _8"></span>Board{" "}
                                        <span class="_ _8"></span>of <span class="_ _8"></span>Education,{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y64 ff2 fs7 fc0 sc0 ls0 ws0">if requested.</div>
                                      <div class="t m1 x0 h17 y65 ff2 fs7 fc0 sc0 ls0 ws0">6.</div>
                                      <div class="t m0 x16 h17 y65 ff1 fs7 fc0 sc0 ls0 ws0">
                                        CONTRACT CHANGES.{" "}
                                        <span class="ff2">
                                          No changes or alterations to this contract shall be made without specific
                                          prior written approval by the <span class="_ _1"></span>Diswict.
                                        </span>
                                      </div>
                                      <div class="t m1 x0 h12 y66 ff2 fs6 fc0 sc0 ls0 ws0">
                                        7.<span class="_ _e"> </span>
                                        <span class="ff1">
                                          SUBSTITUTIONS. <span class="_ _2"></span>
                                        </span>
                                        No <span class="_ _2"></span>substitutions <span class="_ _4"></span>of{" "}
                                        <span class="_ _2"></span>materials <span class="_ _4"></span>or{" "}
                                        <span class="_ _2"></span>service
                                        <span class="_ _2"></span>from <span class="_ _4"></span>those{" "}
                                        <span class="_ _2"></span>specified
                                        <span class="_ _2"></span>in <span class="_ _4"></span>the{" "}
                                        <span class="_ _2"></span>Scope <span class="_ _2"></span>of{" "}
                                        <span class="_ _4"></span>Work <span class="_ _2"></span>shall{" "}
                                        <span class="_ _4"></span>be <span class="_ _2"></span>made{" "}
                                        <span class="_ _2"></span>without <span class="_ _4"></span>the{" "}
                                        <span class="_ _2"></span>prior <span class="_ _2"></span>written{" "}
                                        <span class="_ _4"></span>approval <span class="_ _2"></span>of{" "}
                                      </div>
                                      <div class="t m1 x0 h12 y67 ff2 fs6 fc0 sc0 ls0 ws0">
                                        the <span class="_ _2"></span>District.
                                      </div>
                                      <div class="t m1 x0 h17 y68 ff2 fs7 fc0 sc0 ls0 ws0">8.</div>
                                      <div class="t m0 x16 h17 y68 ff1 fs7 fc0 sc0 ls0 ws0">
                                        ACCESS TO WORK.{" "}
                                        <span class="ff2">
                                          District representatives shall at all times have access to work wherever it is
                                          in preparation or <span class="_ _4"></span>progress.
                                        </span>
                                      </div>
                                      <div class="t m1 x0 h17 y69 ff2 fs7 fc0 sc0 ls0 ws0">9.</div>
                                      <div class="t m0 x16 h17 y69 ff1 fs7 fc0 sc0 ls0 ws0">
                                        PROTECTION <span class="_ _2"></span>OF <span class="_ _4"></span>WORK{" "}
                                        <span class="_ _4"></span>AND <span class="_ _2"></span>PROPERTY.{" "}
                                        <span class="_ _4"></span>
                                        <span class="ff2">
                                          The <span class="_ _2"></span>Provider <span class="_ _4"></span>shall{" "}
                                          <span class="_ _4"></span>maintain <span class="_ _2"></span>at
                                          <span class="_ _4"></span>all <span class="_ _4"></span>times,{" "}
                                          <span class="_ _2"></span>as
                                          <span class="_ _4"></span>required <span class="_ _2"></span>by{" "}
                                          <span class="_ _4"></span>conditions <span class="_ _4"></span>and{" "}
                                          <span class="_ _2"></span>progress <span class="_ _4"></span>of{" "}
                                          <span class="_ _4"></span>work,
                                          <span class="_ _2"></span>all <span class="_ _4"></span>necessary{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y6a ff2 fs7 fc0 sc0 ls0 ws0">
                                        safeguards <span class="_ _b"></span>for <span class="_ _b"></span>the{" "}
                                        <span class="_ _b"></span>protection <span class="_ _4"></span>of{" "}
                                        <span class="_ _b"> </span>employees <span class="_ _b"> </span>and{" "}
                                        <span class="_ _b"> </span>the
                                        <span class="_ _b"> </span>public. <span class="_ _b"> </span>In{" "}
                                        <span class="_ _b"> </span>an <span class="_ _b"> </span>emergency{" "}
                                        <span class="_ _b"></span>affecting <span class="_ _b"></span>life{" "}
                                        <span class="_ _b"></span>and <span class="_ _b"></span>safety{" "}
                                        <span class="_ _b"></span>of <span class="_ _4"></span>life{" "}
                                        <span class="_ _b"> </span>or <span class="_ _b"> </span>of{" "}
                                        <span class="_ _b"> </span>work <span class="_ _b"> </span>or{" "}
                                        <span class="_ _b"> </span>of <span class="_ _b"> </span>adjoining{" "}
                                        <span class="_ _b"> </span>propeuy,
                                        <span class="_ _b"> </span>Provider,{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y6b ff2 fs7 fc0 sc0 ls0 ws0">
                                        without special instruction or authorization from Diswict, is permitted to act
                                        at his discretion to prevent such threatened loss or <span class="_ _2"></span>
                                        injury.
                                      </div>
                                      <div class="t m1 x0 h17 y6c ff2 fs7 fc0 sc0 ls0 ws0">10.</div>
                                      <div class="t m0 x2b h17 y6c ff1 fs7 fc0 sc0 ls0 ws0">
                                        ASSIGNMENT OF CONTRACT <span class="_ _2"></span>AND PUCHASE ORDER.{" "}
                                        <span class="_ _2"></span>
                                        <span class="ff2">
                                          The Provider shall <span class="_ _2"></span>not assign or{" "}
                                          <span class="_ _2"></span>transfer by operation
                                          <span class="_ _2"></span>of law or <span class="_ _2"></span>otherwise any or
                                          all <span class="_ _2"></span>of its{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y6d ff2 fs7 fc0 sc0 ls0 ws0">
                                        rights, burdens, duties, or obligations under this contract without the prior
                                        written consent of the <span class="_ _5"> </span>District.
                                      </div>
                                      <div class="t m0 x0 h17 y6e ff2 fs7 fc0 sc0 ls0 ws0">
                                        I <span class="_ _2"></span>l.{" "}
                                        <span class="ff1">
                                          FORCE <span class="_ _2"></span>MAJEURE <span class="_ _2"></span>CLAUSE.{" "}
                                          <span class="_ _2"></span>
                                        </span>
                                        The <span class="_ _2"></span>parties <span class="_ _2"></span>to{" "}
                                        <span class="_ _2"></span>the <span class="_ _2"></span>Contract{" "}
                                        <span class="_ _2"></span>shall be <span class="_ _2"></span>excused{" "}
                                        <span class="_ _2"></span>from
                                        <span class="_ _2"></span>performance <span class="_ _2"></span>thereunder{" "}
                                        <span class="_ _2"></span>during <span class="_ _2"></span>the{" "}
                                        <span class="_ _2"></span>time <span class="_ _2"></span>and to{" "}
                                        <span class="_ _2"></span>the <span class="_ _2"></span>extent{" "}
                                        <span class="_ _2"></span>that <span class="_ _2"></span>they{" "}
                                        <span class="_ _2"></span>are{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y6f ff2 fs7 fc0 sc0 ls0 ws0">
                                        prevented <span class="_ _5"> </span>from <span class="_ _5"> </span>obtaining,{" "}
                                        <span class="_ _5"> </span>delivering, <span class="_ _5"></span>or{" "}
                                        <span class="_ _5"> </span>performing <span class="_ _5"> </span>by{" "}
                                        <span class="_ _5"></span>act <span class="_ _5"> </span>of{" "}
                                        <span class="_ _5"> </span>God, <span class="_ _f"></span>fire,{" "}
                                        <span class="_ _5"> </span>strike, <span class="_ _5"> </span>loss,{" "}
                                        <span class="_ _5"></span>or <span class="_ _5"> </span>shouage{" "}
                                        <span class="_ _5"> </span>of <span class="_ _5"></span>wanspouation{" "}
                                        <span class="_ _5"> </span>facilities, <span class="_ _5"> </span>lock-out{" "}
                                        <span class="_ _5"> </span>commandeering <span class="_ _5"> </span>of{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y70 ff2 fs7 fc0 sc0 ls0 ws0">
                                        materials, products, plants or <span class="_ _7"></span>facilities by the{" "}
                                        <span class="_ _1"></span>government when satisfactory evidence thereof is{" "}
                                        <span class="_ _1"></span>presented <span class="_ _2"></span>to the other{" "}
                                        <span class="_ _1"></span>party(ies), <span class="_ _b"> </span>provided that{" "}
                                        <span class="_ _1"></span>it <span class="_ _8"></span>is{" "}
                                        <span class="_ _1"></span>satisfactorily
                                      </div>
                                      <div class="t m0 x0 h17 y71 ff2 fs7 fc0 sc0 ls0 ws0">
                                        established that the non-performance is not due to the fault or neglect of the
                                        party not <span class="_ _4"></span>performing.
                                      </div>
                                      <div class="t m6 x0 h17 y72 ff2 fs7 fc0 sc0 ls0 ws0">12.</div>
                                      <div class="t m0 x2b h17 y72 ff1 fs7 fc0 sc0 ls0 ws0">
                                        HOLD <span class="_ _4"></span>HARMLESS <span class="_ _b"> </span>AGREEMENT.{" "}
                                        <span class="_ _b"></span>
                                        <span class="ff2">
                                          The <span class="_ _4"></span>Provider <span class="_ _b"></span>shall{" "}
                                          <span class="_ _4"></span>save,
                                          <span class="_ _b"></span>defend, <span class="_ _4"></span>hold{" "}
                                          <span class="_ _b"></span>harmless <span class="_ _b"></span>and{" "}
                                          <span class="_ _4"></span>indemnify <span class="_ _b"></span>the{" "}
                                          <span class="_ _4"></span>District <span class="_ _b"> </span>from
                                          <span class="_ _b"></span>and <span class="_ _4"></span>against{" "}
                                          <span class="_ _b"></span>any
                                          <span class="_ _4"></span>and <span class="_ _b"></span>all{" "}
                                          <span class="_ _4"></span>losses,
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y73 ff2 fs7 fc0 sc0 ls0 ws0">
                                        damages, <span class="_ _2"></span>liabilities, claims,{" "}
                                        <span class="_ _2"></span>and <span class="_ _2"></span>costs{" "}
                                        <span class="_ _2"></span>of
                                        <span class="_ _2"></span>whatsoever <span class="_ _2"></span>kind{" "}
                                        <span class="_ _2"></span> and
                                        <span class="_ _2"></span> <span class="_ _2"></span>nature{" "}
                                        <span class="_ _2"></span>for <span class="_ _2"></span>injury{" "}
                                        <span class="_ _2"></span> <span class="_ _2"></span>to{" "}
                                        <span class="_ _2"></span>or death <span class="_ _2"></span>of{" "}
                                        <span class="_ _2"></span>any <span class="_ _2"></span>person{" "}
                                        <span class="_ _2"></span> <span class="_ _2"></span>and{" "}
                                        <span class="_ _2"></span>for <span class="_ _2"></span>loss or{" "}
                                        <span class="_ _2"></span>damage <span class="_ _2"></span>{" "}
                                        <span class="_ _2"></span>to <span class="_ _2"></span>any{" "}
                                        <span class="_ _2"></span>property <span class="_ _2"></span>occurring{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y74 ff2 fs7 fc0 sc0 ls0 ws0">
                                        in connection <span class="_ _2"></span>with <span class="_ _2"></span>or in{" "}
                                        <span class="_ _2"></span>any <span class="_ _2"></span>way incident
                                        <span class="_ _2"></span>to <span class="_ _2"></span>or arising{" "}
                                        <span class="_ _2"></span>out
                                        <span class="_ _2"></span>of <span class="_ _2"></span>the occupancy,{" "}
                                        <span class="_ _2"></span>use,
                                        <span class="_ _2"></span>service, operations, <span class="_ _2"></span>or{" "}
                                        <span class="_ _2"></span>performance of <span class="_ _2"></span>work{" "}
                                        <span class="_ _2"></span>on the <span class="_ _2"></span>property{" "}
                                        <span class="_ _2"></span>under the <span class="_ _2"></span>terms{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y75 ff2 fs7 fc0 sc0 ls0 ws0">
                                        of this contract, resulting in whole or <span class="_ _2"></span>in pan
                                        <span class="_ _10"> </span>negligent acts or <span class="_ _7"></span>
                                        omissions <span class="_ _4"></span>of the <span class="_ _1"></span>Provider,
                                        any subproviders, <span class="_ _2"></span>or <span class="_ _2"></span>any
                                        employee, agent <span class="_ _8"></span>or <span class="_ _1"></span>
                                        representative <span class="_ _1"></span>of{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y76 ff2 fs7 fc0 sc0 ls0 ws0">
                                        Provider and/or its subproviders.
                                      </div>
                                      <div class="t m6 x0 h17 y77 ff2 fs7 fc0 sc0 ls0 ws0">13.</div>
                                      <div class="t m0 x2b h17 y77 ff1 fs7 fc0 sc0 ls0 ws0">
                                        PAYMENT.{" "}
                                        <span class="ff2">
                                          Unless otherwise <span class="_ _11"> </span>specified, the Provider{" "}
                                          <span class="_ _11"> </span>shall render invoices <span class="_ _11"> </span>
                                          in triplicate for <span class="_ _11"> </span>materials delivered or{" "}
                                          <span class="_ _11"> </span>services performed under{" "}
                                          <span class="_ _11"></span>the{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y78 ff2 fs7 fc0 sc0 ls0 ws0">
                                        ContracfPurchase<span class="_ _12"> </span>The
                                        <span class="_ _2"></span>District <span class="_ _4"></span>shall{" "}
                                        <span class="_ _4"></span>make
                                        <span class="_ _2"></span>payment <span class="_ _4"></span>for{" "}
                                        <span class="_ _2"></span>materials,
                                        <span class="_ _4"></span>supplies <span class="_ _4"></span>or{" "}
                                        <span class="_ _2"></span>other
                                        <span class="_ _4"></span>services <span class="_ _4"></span>furnished{" "}
                                        <span class="_ _2"></span>under <span class="_ _4"></span>this{" "}
                                        <span class="_ _2"></span>Contract
                                        <span class="_ _4"></span>as <span class="_ _4"></span>agreed{" "}
                                        <span class="_ _2"></span>within <span class="_ _4"></span>thirty{" "}
                                        <span class="_ _4"></span>(30){" "}
                                      </div>
                                      <div class="t m0 x0 h17 y79 ff2 fs7 fc0 sc0 ls0 ws0">
                                        days after delivery to <span class="_ _2"></span>and approval by the authorized{" "}
                                        <span class="_ _2"></span>District representative of all invoices{" "}
                                        <span class="_ _2"></span>and other documentary evidence reasonably
                                        <span class="_ _2"></span>required by the District{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y7a ff2 fs7 fc0 sc0 ls0 ws0">
                                        (which approval shall not be unreasonably <span class="_ _5"> </span>withheld).
                                      </div>
                                      <div class="t m6 x0 h17 y7b ff2 fs7 fc0 sc0 ls0 ws0">14.</div>
                                      <div class="t m0 x2b h17 y7b ff1 fs7 fc0 sc0 ls0 ws0">
                                        PERAI <span class="_ _b"></span>TS <span class="_ _8"></span>AND LICENSES.{" "}
                                        <span class="ff2">
                                          The <span class="_ _1"></span>Provider <span class="_ _8"></span>shall secure{" "}
                                          <span class="_ _8"></span>and maintain in <span class="_ _8"></span>force,{" "}
                                          <span class="_ _1"></span>at <span class="_ _8"></span>Provider&apos;s sole{" "}
                                          <span class="_ _1"></span>cost <span class="_ _1"></span>and{" "}
                                          <span class="_ _8"></span>expense, such <span class="_ _1"></span>licenses{" "}
                                          <span class="_ _1"></span>and <span class="_ _1"></span>permits
                                          <span class="_ _1"></span>as are <span class="_ _1"></span>required{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y7c ff2 fs7 fc0 sc0 ls0 ws0">
                                        by law, in connection with the furnishing of services, materials, or supplies
                                        herein <span class="_ _7"></span>listed.
                                      </div>
                                      <div class="t m6 x0 h17 y7d ff2 fs7 fc0 sc0 ls0 ws0">15.</div>
                                      <div class="t m0 x2b h17 y7d ff1 fs7 fc0 sc0 ls0 ws0">
                                        PROVIDER <span class="_ _2"></span>NOT <span class="_ _2"></span>OFFICER,{" "}
                                        <span class="_ _2"></span>EMPLOYEE, <span class="_ _4"></span>OR
                                        <span class="_ _2"></span>AGENT <span class="_ _2"></span>OF{" "}
                                        <span class="_ _2"></span>DISTRICT.
                                        <span class="_ _2"></span>
                                        <span class="ff2">
                                          While <span class="_ _4"></span>engaged <span class="_ _2"></span>in{" "}
                                          <span class="_ _2"></span>carrying <span class="_ _2"></span>out
                                          <span class="_ _2"></span>other <span class="_ _4"></span>terms{" "}
                                          <span class="_ _2"></span>and
                                          <span class="_ _2"></span>conditions <span class="_ _2"></span>of{" "}
                                          <span class="_ _2"></span>the
                                          <span class="_ _4"></span>purchase{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y7e ff2 fs7 fc0 sc0 ls0 ws0">
                                        order, the Provider is an independent Provider, and not an officer, employee,
                                        agent, pauner, or joint venture of <span class="_ _2"></span>the District.
                                      </div>
                                      <div class="t m6 x0 h17 y7f ff2 fs7 fc0 sc0 ls0 ws0">16.</div>
                                      <div class="t m0 x2b h17 y7f ff1 fs7 fc0 sc0 ls0 ws0">
                                        ANTI-DISCRIMINATION. <span class="_ _2"></span>
                                        <span class="ff2">
                                          Pursuant <span class="_ _2"></span>to <span class="_ _2"></span>Board{" "}
                                          <span class="_ _2"></span>Policy <span class="_ _2"></span>4030,
                                          <span class="_ _2"></span>Glendale <span class="_ _2"></span>Unified{" "}
                                          <span class="_ _2"></span>School <span class="_ _2"></span>Diswict{" "}
                                          <span class="_ _4"></span>prohibits <span class="_ _2"></span>discrimination{" "}
                                          <span class="_ _2"></span>and/or <span class="_ _2"></span>harassment{" "}
                                          <span class="_ _2"></span>of
                                          <span class="_ _2"></span>any <span class="_ _2"></span>person{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y80 ff2 fs7 fc0 sc0 ls0 ws0">
                                        based <span class="_ _5"> </span>on <span class="_ _f"> </span>race,{" "}
                                        <span class="_ _f"> </span>color, <span class="_ _f"> </span>national
                                        <span class="_ _f"> </span>origin, <span class="_ _5"> </span>ancestry, re
                                        <span class="_ _1"></span>ligious <span class="_ _f"> </span>creed,{" "}
                                        <span class="_ _f"> </span>age,
                                        <span class="_ _f"> </span>marital <span class="_ _f"> </span>status,{" "}
                                        <span class="_ _5"></span>pregnancy, <span class="_ _f"> </span>physical{" "}
                                        <span class="_ _f"> </span>or <span class="_ _f"> </span>mental{" "}
                                        <span class="_ _f"> </span>disability, <span class="_ _5"></span>medical{" "}
                                        <span class="_ _f"> </span>condition, <span class="_ _f"> </span>genetic{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y81 ff2 fs7 fc0 sc0 ls0 ws0">
                                        information, veteran <span class="_ _2"></span>status, gender,{" "}
                                        <span class="_ _2"></span>gender identity, <span class="_ _2"></span>gender
                                        expression, <span class="_ _2"></span>sex or <span class="_ _2"></span>sexual
                                        orientation. <span class="_ _2"></span>Therefore, the <span class="_ _2"></span>
                                        Provider <span class="_ _2"></span>agrees to <span class="_ _2"></span>comply
                                        with <span class="_ _2"></span>the applicable{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y82 ff2 fs7 fc0 sc0 ls0 ws0">
                                        Federal and <span class="_ _2"></span>California
                                        <span class="_ _2"></span>Laws, including, <span class="_ _2"></span>but not{" "}
                                        <span class="_ _2"></span>limited <span class="_ _2"></span>to, the{" "}
                                        <span class="_ _2"></span>California Fair <span class="_ _2"></span>Employment{" "}
                                        <span class="_ _2"></span>Practice Act, <span class="_ _2"></span>beginning with{" "}
                                        <span class="_ _2"></span>Labor <span class="_ _2"></span>Code, Section{" "}
                                        <span class="_ _2"></span>1410
                                        <span class="_ _2"></span>and Labor{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y83 ff2 fs7 fc0 sc0 ls0 ws0">
                                        Code, Section 1735. In addition, the Provider agrees to require such compliance
                                        by all subproviders employed on the Contract by <span class="_ _5"> </span>him.
                                      </div>
                                      <div class="t m6 x0 h17 y84 ff2 fs7 fc0 sc0 ls0 ws0">17.</div>
                                      <div class="t m0 x2b h17 y84 ff1 fs7 fc0 sc0 ls0 ws0">
                                        PROVIDER&apos;S <span class="_ _5"></span>INSURANCE. <span class="_ _5"> </span>
                                        <span class="ff2">
                                          The <span class="_ _f"></span>Provider <span class="_ _5"> </span>shall{" "}
                                          <span class="_ _f"> </span>not <span class="_ _5"> </span>commence{" "}
                                          <span class="_ _5"> </span>work <span class="_ _f"></span>under{" "}
                                          <span class="_ _5"> </span>this <span class="_ _f"> </span>Contract{" "}
                                          <span class="_ _5"> </span>until <span class="_ _5"> </span>he{" "}
                                          <span class="_ _f"> </span>has
                                          <span class="_ _5"> </span>obtained <span class="_ _f"> </span>the{" "}
                                          <span class="_ _5"></span>insurance <span class="_ _5"> </span>required{" "}
                                          <span class="_ _f"> </span>under <span class="_ _5"> </span>this{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x0 h17 y85 ff2 fs7 fc0 sc0 ls0 ws0">
                                        paragraph <span class="_ _4"></span>and <span class="_ _2"></span>satisfactory{" "}
                                        <span class="_ _4"></span>proof <span class="_ _4"></span>of
                                        <span class="_ _4"></span>such <span class="_ _4"></span>insurance{" "}
                                        <span class="_ _4"></span>has
                                        <span class="_ _2"></span>been <span class="_ _4"></span>submitted{" "}
                                        <span class="_ _4"></span>to
                                        <span class="_ _4"></span>Diswict <span class="_ _4"></span>and{" "}
                                        <span class="_ _4"></span>said <span class="_ _2"></span>insurance{" "}
                                        <span class="_ _4"></span>has <span class="_ _4"></span>been{" "}
                                        <span class="_ _4"></span>approved <span class="_ _4"></span>by{" "}
                                        <span class="_ _4"></span>the <span class="_ _4"></span>District.{" "}
                                        <span class="_ _2"></span>Except <span class="_ _4"></span>for
                                        <span class="_ _4"></span>worker&apos;s{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y86 ff2 fs7 fc0 sc0 ls0 ws0">
                                        compensation <span class="_ _b"> </span>insurance,
                                        <span class="_ _5"> </span>the <span class="_ _b"> </span>policy{" "}
                                        <span class="_ _5"> </span>shall
                                        <span class="_ _b"> </span>not <span class="_ _5"> </span>be{" "}
                                        <span class="_ _b"> </span>amended
                                        <span class="_ _5"> </span>or <span class="_ _b"> </span>modified{" "}
                                        <span class="_ _5"> </span>and
                                        <span class="_ _b"> </span>the <span class="_ _5"> </span>coverage{" "}
                                        <span class="_ _b"></span>amounts <span class="_ _5"> </span>shall{" "}
                                        <span class="_ _b"> </span>not <span class="_ _5"></span>be{" "}
                                        <span class="_ _b"> </span>reduced <span class="_ _5"> </span>without{" "}
                                        <span class="_ _b"></span>the <span class="_ _5"> </span>District&apos;s{" "}
                                        <span class="_ _b"></span>prior <span class="_ _b"> </span>written{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y87 ff2 fs7 fc0 sc0 ls0 ws0">
                                        consent, <span class="_ _4"></span>and, <span class="_ _4"></span>the{" "}
                                        <span class="_ _4"></span>District <span class="_ _4"></span>shall{" "}
                                        <span class="_ _4"></span>be <span class="_ _4"></span>named{" "}
                                        <span class="_ _4"></span>as <span class="_ _4"></span>an{" "}
                                        <span class="_ _4"></span>additional <span class="_ _4"></span>insured
                                        <span class="_ _4"></span>and <span class="_ _4"></span>be{" "}
                                        <span class="_ _4"></span>furnished <span class="_ _4"></span>thirty{" "}
                                        <span class="_ _4"></span>(30) <span class="_ _4"></span>days{" "}
                                        <span class="_ _4"></span>written <span class="_ _4"></span>notice{" "}
                                        <span class="_ _4"></span>prior
                                        <span class="_ _4"></span>to <span class="_ _4"></span>cancellation.{" "}
                                        <span class="_ _4"></span>In
                                        <span class="_ _4"></span>the <span class="_ _b"></span>event{" "}
                                        <span class="_ _2"></span>that <span class="_ _4"></span>the{" "}
                                      </div>
                                      <div class="t m0 x0 h17 y88 ff2 fs7 fc0 sc0 ls0 ws0">
                                        insurance requirements cannot be met, please turn in a signed &quot;Hold
                                        Harmless and Indemnification Agreement.&quot;
                                      </div>
                                      <div class="t m1 x14 h5 y89 ff2 fs2 fc0 sc0 ls0 ws0">Page 3 of 4</div>
                                    </div>
                                    <div
                                      class="pi"
                                      data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
                                    ></div>
                                  </div>
                                  <div id="pf4" class="pf w0 h0" data-page-no="4">
                                    <div class="pc pc4 w0 h0">
                                      <div class="t m6 x2c h17 y8b ff2 fs7 fc0 sc0 ls0 ws0">a)</div>
                                      <div class="t m0 x2d h17 y8b ff1 fs7 fc0 sc0 ls0 ws0">
                                        PROVIDER&apos;S <span class="_ _2"></span>PUBLIC
                                        <span class="_ _4"></span>LIABILITY <span class="_ _4"></span>AND{" "}
                                        <span class="_ _2"></span>PROPERTY
                                        <span class="_ _4"></span>DAMAGE <span class="_ _2"></span>INSUR
                                        <span class="_ _2"></span>ANCE.
                                        <span class="_ _2"></span>
                                        <span class="ff2">
                                          The <span class="_ _4"></span>Provider <span class="_ _2"></span>shall{" "}
                                          <span class="_ _4"></span>procure <span class="_ _4"></span>and
                                          <span class="_ _2"></span>shall <span class="_ _4"></span>maintain{" "}
                                          <span class="_ _2"></span>during <span class="_ _4"></span>the{" "}
                                          <span class="_ _4"></span>life
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 y8c ff2 fs7 fc0 sc0 ls0 ws0">
                                        of <span class="_ _1"></span>his <span class="_ _8"></span>contract,
                                        Provider&apos;s <span class="_ _1"></span>Public Liability{" "}
                                        <span class="_ _8"></span>Insurance <span class="_ _1"></span>in{" "}
                                        <span class="_ _1"></span>an <span class="_ _1"></span>amount{" "}
                                        <span class="_ _1"></span>not <span class="_ _8"></span>less{" "}
                                        <span class="_ _1"></span>than <span class="_ _1"></span>$1,000,000 for{" "}
                                        <span class="_ _7"></span>injuries, including <span class="_ _8"></span>
                                        accidental death to <span class="_ _7"></span>any <span class="_ _8"></span>one
                                        person, and <span class="_ _1"></span>subject{" "}
                                      </div>
                                      <div class="t m0 x7 h17 y8d ff2 fs7 fc0 sc0 ls0 ws0">
                                        to <span class="_ _2"></span>the <span class="_ _2"></span>limit{" "}
                                        <span class="_ _2"></span>for <span class="_ _2"></span>each{" "}
                                        <span class="_ _4"></span>person, <span class="_ _2"></span>in{" "}
                                        <span class="_ _2"></span>an <span class="_ _2"></span>amount{" "}
                                        <span class="_ _2"></span>not <span class="_ _4"></span>less{" "}
                                        <span class="_ _2"></span>than <span class="_ _2"></span>$1,000,000{" "}
                                        <span class="_ _2"></span>on <span class="_ _2"></span>account{" "}
                                        <span class="_ _4"></span>of <span class="_ _2"></span>one{" "}
                                        <span class="_ _2"></span>accident, <span class="_ _2"></span>and{" "}
                                        <span class="_ _2"></span>Provider&apos;s <span class="_ _4"></span>Property{" "}
                                        <span class="_ _2"></span>Damage <span class="_ _2"></span>Insurance{" "}
                                        <span class="_ _2"></span>in
                                        <span class="_ _2"></span>an <span class="_ _4"></span>amount{" "}
                                        <span class="_ _2"></span>not{" "}
                                      </div>
                                      <div class="t m0 x7 h17 y8e ff2 fs7 fc0 sc0 ls0 ws0">
                                        less than <span class="_ _2"></span>$1,000,000.
                                      </div>
                                      <div class="t m6 x7 h17 y8f ff2 fs7 fc0 sc0 ls0 ws0">18.</div>
                                      <div class="t m0 x2c h17 y8f ff1 fs7 fc0 sc0 ls0 ws0">
                                        COMPLIANCE <span class="_ _2"></span>WITH <span class="_ _2"></span>LAWS.{" "}
                                        <span class="ff2">
                                          P<span class="_ _2"></span>rovider shall <span class="_ _2"></span>give{" "}
                                          <span class="_ _2"></span>all <span class="_ _2"></span>notices
                                          <span class="_ _2"></span>and <span class="_ _2"></span>comply{" "}
                                          <span class="_ _2"></span>with
                                          <span class="_ _2"></span>all <span class="_ _2"></span>laws,{" "}
                                          <span class="_ _2"></span>ordinances, <span class="_ _2"></span>rules{" "}
                                          <span class="_ _2"></span>and <span class="_ _2"></span>regulations bearing{" "}
                                          <span class="_ _2"></span>on <span class="_ _2"></span>conduct{" "}
                                          <span class="_ _2"></span>or <span class="_ _2"></span>work{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 y90 ff2 fs7 fc0 sc0 ls0 ws0">
                                        as <span class="_ _1"></span>indicated <span class="_ _2"></span>or{" "}
                                        <span class="_ _1"></span>specified. <span class="_ _2"></span>If Provider
                                        observes <span class="_ _2"></span>that any <span class="_ _1"></span>of the
                                        work required by this contract is at <span class="_ _8"></span>variance{" "}
                                        <span class="_ _2"></span>with any <span class="_ _1"></span>such laws,
                                        ordinances, <span class="_ _4"></span>rules or regulations,
                                      </div>
                                      <div class="t m0 x7 h17 y91 ff2 fs7 fc0 sc0 ls0 ws0">
                                        Provider shall notify the District, <span class="_ _2"></span>in writing, and,
                                        at <span class="_ _1"></span>the sole option of the District,{" "}
                                        <span class="_ _2"></span>any necessary changes <span class="_ _2"></span>to the{" "}
                                        <span class="_ _1"></span>scope <span class="_ _2"></span>of{" "}
                                        <span class="_ _1"></span>work <span class="_ _2"></span>shall be{" "}
                                        <span class="_ _1"></span>made and this Contract{" "}
                                      </div>
                                      <div class="t m0 x7 h17 y92 ff2 fs7 fc0 sc0 ls0 ws0">
                                        shall <span class="_ _b"> </span>be <span class="_ _b"> </span>appropriately{" "}
                                        <span class="_ _b"> </span>amended <span class="_ _5"></span>in{" "}
                                        <span class="_ _4"></span>writing, <span class="_ _b"> </span>or{" "}
                                        <span class="_ _5"></span>this <span class="_ _4"></span>Contract{" "}
                                        <span class="_ _5"> </span>shall <span class="_ _4"></span>be{" "}
                                        <span class="_ _5"> </span>terminated <span class="_ _4"></span>effective
                                        <span class="_ _5"> </span>upon <span class="_ _4"></span>Provider&apos;s{" "}
                                        <span class="_ _b"></span>receipt <span class="_ _5"> </span>of{" "}
                                        <span class="_ _4"></span>a <span class="_ _5"></span>written{" "}
                                        <span class="_ _4"></span>termination <span class="_ _5"> </span>notice{" "}
                                        <span class="_ _4"></span>from <span class="_ _b"> </span>the{" "}
                                      </div>
                                      <div class="t m0 x7 h17 y93 ff2 fs7 fc0 sc0 ls0 ws0">
                                        District. <span class="_ _b"></span>If <span class="_ _b"></span>Provider{" "}
                                        <span class="_ _b"></span>performs <span class="_ _b"></span>any
                                        <span class="_ _b"></span>work <span class="_ _b"></span>knowing{" "}
                                        <span class="_ _b"></span>it <span class="_ _b"></span>to{" "}
                                        <span class="_ _b"></span>be <span class="_ _b"></span>in{" "}
                                        <span class="_ _b"></span>violation <span class="_ _b"></span>{" "}
                                        <span class="_ _b"></span>of <span class="_ _b"></span>{" "}
                                        <span class="_ _b"></span>such <span class="_ _b"></span>{" "}
                                        <span class="_ _b"></span>laws, <span class="_ _b"></span>{" "}
                                        <span class="_ _b"></span>ordinances, <span class="_ _4"></span>{" "}
                                        <span class="_ _b"> </span>rules <span class="_ _b"> </span>{" "}
                                        <span class="_ _b"> </span>or <span class="_ _b"> </span>{" "}
                                        <span class="_ _b"> </span>regulations,
                                        <span class="_ _b"> </span>and <span class="_ _b"> </span>without{" "}
                                        <span class="_ _b"> </span>first
                                        <span class="_ _b"> </span>notifying <span class="_ _b"> </span>the{" "}
                                      </div>
                                      <div class="t m0 x7 h17 y94 ff2 fs7 fc0 sc0 ls0 ws0">
                                        District of such violation, Provider shall bear all costs arising{" "}
                                        <span class="_ _5"> </span>therefrom.
                                      </div>
                                      <div class="t m6 x7 h17 y95 ff2 fs7 fc0 sc0 ls0 ws0">19.</div>
                                      <div class="t m0 x2c h17 y95 ff1 fs7 fc0 sc0 ls0 ws0">
                                        TIME IS OF THE ESSENCE.{" "}
                                        <span class="ff2">
                                          Time is of the essence in the performance of and compliance with each of the
                                          provisions and conditions of this <span class="_ _5"> </span>contract.
                                        </span>
                                      </div>
                                      <div class="t m6 x7 h17 y96 ff2 fs7 fc0 sc0 ls0 ws0">20.</div>
                                      <div class="t m0 x2c h17 y96 ff1 fs7 fc0 sc0 ls0 ws0">
                                        GOVERNING LAW.{" "}
                                        <span class="ff2">
                                          This contract shall be governed by and construed in accordance with the laws
                                          of the State of <span class="_ _4"></span>California.
                                        </span>
                                      </div>
                                      <div class="t m6 x7 h17 y97 ff2 fs7 fc0 sc0 ls0 ws0">21.</div>
                                      <div class="t m0 x2e h17 y97 ff1 fs7 fc0 sc0 ls0 ws0">
                                        ATTORNEYS&apos; <span class="_ _2"></span>FEES.
                                        <span class="_ _4"></span>
                                        <span class="ff2">
                                          If <span class="_ _4"></span>any <span class="_ _4"></span>action{" "}
                                          <span class="_ _4"></span>is <span class="_ _2"></span>brought
                                          <span class="_ _4"></span>by <span class="_ _4"></span>either{" "}
                                          <span class="_ _4"></span>pany
                                          <span class="_ _2"></span>against <span class="_ _4"></span>the{" "}
                                          <span class="_ _4"></span>other
                                          <span class="_ _4"></span>party <span class="_ _4"></span>hereunder,{" "}
                                          <span class="_ _2"></span>each <span class="_ _4"></span>party{" "}
                                          <span class="_ _4"></span>shall
                                          <span class="_ _4"></span>be <span class="_ _2"></span>responsible{" "}
                                          <span class="_ _4"></span>for
                                          <span class="_ _4"></span>its <span class="_ _4"></span>own{" "}
                                          <span class="_ _2"></span>expenses,
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 y98 ff2 fs7 fc0 sc0 ls0 ws0">
                                        including legal and accounting fees, in connection with the prosecution or
                                        defense of <span class="_ _b"></span>such action.
                                      </div>
                                      <div class="t m6 x7 h12 y99 ff2 fs6 fc0 sc0 ls0 ws0">22.</div>
                                      <div class="t m1 x2c h12 y99 ff2 fs6 fc0 sc0 ls0 ws0">
                                        NO <span class="_ _5"> </span>ORAL <span class="_ _5"> </span>MODIFICATION.{" "}
                                        <span class="_ _5"> </span>Any <span class="_ _5"></span>waiver,{" "}
                                        <span class="_ _5"> </span>amendment, <span class="_ _b"> </span>modification,{" "}
                                        <span class="_ _5"> </span>consent <span class="_ _5"> </span>or{" "}
                                        <span class="_ _5"></span>acquiescence <span class="_ _5"> </span>with{" "}
                                        <span class="_ _5"> </span>respect <span class="_ _5"> </span>to{" "}
                                        <span class="_ _5"> </span>this <span class="_ _5"> </span>contract
                                        <span class="_ _b"> </span>or <span class="_ _5"> </span>any{" "}
                                        <span class="_ _5"> </span>provision
                                        <span class="_ _5"> </span>of <span class="_ _5"> </span>this{" "}
                                      </div>
                                      <div class="t m1 x7 h12 y9a ff2 fs6 fc0 sc0 ls0 ws0">
                                        contract <span class="_ _4"></span>or <span class="_ _b"> </span>with{" "}
                                        <span class="_ _4"></span>respect <span class="_ _b"> </span>to{" "}
                                        <span class="_ _4"></span>any <span class="_ _b"></span>failure{" "}
                                        <span class="_ _4"></span>to <span class="_ _b"></span>perform{" "}
                                        <span class="_ _4"></span>in <span class="_ _b"></span>accordance
                                        <span class="_ _4"></span>therewith <span class="_ _b"></span>shall{" "}
                                        <span class="_ _4"></span>be
                                        <span class="_ _b"></span>set <span class="_ _4"></span>fouh{" "}
                                        <span class="_ _b"></span>in <span class="_ _4"></span>writing{" "}
                                        <span class="_ _b"></span>and <span class="_ _4"></span>duly{" "}
                                        <span class="_ _b"></span>executed <span class="_ _4"></span>by{" "}
                                        <span class="_ _b"></span>or <span class="_ _4"></span>on{" "}
                                        <span class="_ _b"></span>behalf <span class="_ _4"></span>of{" "}
                                        <span class="_ _b"></span>the <span class="_ _4"></span>party{" "}
                                        <span class="_ _b"></span>to <span class="_ _4"></span>be{" "}
                                      </div>
                                      <div class="t m1 x7 h12 y9b ff2 fs6 fc0 sc0 ls0 ws0">
                                        bound <span class="_ _4"></span>thereby.
                                      </div>
                                      <div class="t m6 x7 h17 y9c ff2 fs7 fc0 sc0 ls0 ws0">23.</div>
                                      <div class="t m0 x2c h17 y9c ff1 fs7 fc0 sc0 ls0 ws0">
                                        PROVISIONS <span class="_ _b"> </span>REQUIRED
                                        <span class="_ _5"> </span>BY <span class="_ _b"></span>LAW{" "}
                                        <span class="_ _b"> </span>DEEMED <span class="_ _b"> </span>INSERTED.{" "}
                                        <span class="_ _5"> </span>
                                        <span class="ff2">
                                          Each <span class="_ _b"></span>and <span class="_ _b"> </span>every{" "}
                                          <span class="_ _5"></span>provision <span class="_ _b"></span>of{" "}
                                          <span class="_ _b"> </span>law <span class="_ _5"></span>a
                                          <span class="_ _1"></span>nd <span class="_ _5"> </span>clause{" "}
                                          <span class="_ _b"></span>required <span class="_ _b"> </span>by{" "}
                                          <span class="_ _5"> </span>law
                                          <span class="_ _b"></span>to <span class="_ _b"> </span>be{" "}
                                          <span class="_ _b"> </span>inseued
                                          <span class="_ _5"> </span>in <span class="_ _b"></span>this{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 y9d ff2 fs7 fc0 sc0 ls0 ws0">
                                        contract shall be deemed to be inseued herein and this contract shall be read
                                        and enforced as though it <span class="_ _5"> </span>were included herein.
                                      </div>
                                      <div class="t m6 x7 h17 y9e ff2 fs7 fc0 sc0 ls0 ws0">24.</div>
                                      <div class="t m0 x2e h17 y9e ff1 fs7 fc0 sc0 ls0 ws0">
                                        FINGERPRINTING.{" "}
                                        <span class="ff2">
                                          The Provider shall be fingerprinted before commencing services of this
                                          Contract. The cost shall be covered by the <span class="_ _7"></span>District.
                                        </span>
                                      </div>
                                      <div class="t m6 x7 h17 y9f ff2 fs7 fc0 sc0 ls0 ws0">25.</div>
                                      <div class="t m0 x2e h17 y9f ff1 fs7 fc0 sc0 ls0 ws0">
                                        TUBERCULOSIS <span class="_ _5"> </span>TESTING.
                                        <span class="_ _5"> </span>
                                        <span class="ff2">
                                          Before <span class="_ _5"> </span>commencing <span class="_ _5"> </span>
                                          services, <span class="_ _5"> </span>Provider, <span class="_ _b"></span>if{" "}
                                          <span class="_ _5"> </span>working <span class="_ _5"> </span>with{" "}
                                          <span class="_ _5"></span>or <span class="_ _5"> </span>near{" "}
                                          <span class="_ _5"> </span>students, <span class="_ _5"> </span>shall{" "}
                                          <span class="_ _5"> </span>provide <span class="_ _5"></span>proof{" "}
                                          <span class="_ _5"> </span>of <span class="_ _5"> </span>Tuberculosis{" "}
                                          <span class="_ _5"> </span>(TB){" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 ya0 ff2 fs7 fc0 sc0 ls0 ws0">
                                        testing at their own expense to the Human Resources
                                        <span class="_ _2"></span>Department. The TB test must have been conducted
                                        within the prior <span class="_ _8"></span>six months <span class="_ _2"></span>
                                        to the Contract effective{" "}
                                      </div>
                                      <div class="t m0 x7 h17 ya1 ff2 fs7 fc0 sc0 ls0 ws0">date.</div>
                                      <div class="t m6 x7 h12 ya2 ff2 fs6 fc0 sc0 ls0 ws0">26.</div>
                                      <div class="t m1 x2e h12 ya2 ff2 fs6 fc1 sc0 ls0 ws0">
                                        COVID-19 <span class="_ _4"></span>VACCINATION
                                        <span class="_ _4"></span>STATUS. <span class="_ _b"> </span>Before{" "}
                                        <span class="_ _4"></span>commencing <span class="_ _4"></span>services,{" "}
                                        <span class="_ _b"></span>Provider, <span class="_ _4"></span>if{" "}
                                        <span class="_ _4"></span>working
                                        <span class="_ _b"></span>with <span class="_ _4"></span>or{" "}
                                        <span class="_ _4"></span>near <span class="_ _b"></span>students,{" "}
                                        <span class="_ _4"></span>shall <span class="_ _4"></span>provide
                                        <span class="_ _4"></span>proof <span class="_ _b"> </span>that{" "}
                                        <span class="_ _4"></span>they <span class="_ _4"></span>are{" "}
                                        <span class="_ _b"></span>fully{" "}
                                      </div>
                                      <div class="t m1 x7 h12 ya3 ff2 fs6 fc1 sc0 ls0 ws0">
                                        vaccinated for COVID-19 within two weeks prior to starting to provide services
                                        at a District school site to the Human Resources <span class="_ _2"></span>
                                        Depaument.
                                      </div>
                                      <div class="t m6 x7 h17 ya4 ff2 fs7 fc0 sc0 ls0 ws0">27.</div>
                                      <div class="t m0 x2e h17 ya4 ff1 fs7 fc0 sc0 ls0 ws0">
                                        IF <span class="_ _4"></span>WORKING <span class="_ _b"> </span>WITH{" "}
                                        <span class="_ _b"></span>STUDENTS. <span class="_ _4"></span>
                                        <span class="ff2">
                                          Any <span class="_ _b"> </span>Provider <span class="_ _b"></span>working{" "}
                                          <span class="_ _4"></span>with <span class="_ _b"> </span>a{" "}
                                          <span class="_ _b"></span>student(s)
                                          <span class="_ _4"></span>must <span class="_ _b"> </span>be{" "}
                                          <span class="_ _b"></span>supervised <span class="_ _4"></span>by{" "}
                                          <span class="_ _b"> </span>a<span class="_ _b"></span>credentialed{" "}
                                          <span class="_ _4"></span>person <span class="_ _b"></span>or{" "}
                                          <span class="_ _b"></span>must <span class="_ _4"></span>hold{" "}
                                          <span class="_ _b"></span>an <span class="_ _b"></span>Activity{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 ya5 ff2 fs7 fc0 sc0 ls0 ws0">
                                        Supervisor Clearance Certificate issued through the California Commission on
                                        Teacher Credentialing <span class="_ _b"> </span>(CTC).
                                      </div>
                                      <div class="t m6 x7 h17 ya6 ff2 fs7 fc0 sc0 ls0 ws0">28.</div>
                                      <div class="t m0 x2e h17 ya6 ff1 fs7 fc0 sc0 ls0 ws0">
                                        TOBACCO/ALCOHOL/DRUG-FREE <span class="_ _b"></span>WORKPLACE.{" "}
                                        <span class="_ _b"></span>
                                        <span class="ff2">
                                          Pursuant <span class="_ _b"></span>to <span class="_ _b"></span>Board{" "}
                                          <span class="_ _b"></span>Policies
                                          <span class="_ _b"></span>4020 <span class="_ _b"></span>and{" "}
                                          <span class="_ _b"></span>4021,
                                          <span class="_ _b"></span>Glendale <span class="_ _b"></span>Unified{" "}
                                          <span class="_ _b"></span>School <span class="_ _b"></span>District{" "}
                                          <span class="_ _b"></span>is
                                          <span class="_ _b"></span>a <span class="_ _b"></span>tobacco,{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 ya7 ff2 fs7 fc0 sc0 ls0 ws0">
                                        alcohol, and <span class="_ _1"></span>drug-free
                                        <span class="_ _2"></span>district. The Provider <span class="_ _1"></span>shall
                                        not use or <span class="_ _7"></span>be under the influence{" "}
                                        <span class="_ _2"></span>of these substances while on District propeuy or{" "}
                                        <span class="_ _8"></span>during <span class="_ _b"> </span>the performance of{" "}
                                      </div>
                                      <div class="t m0 x7 h17 ya8 ff2 fs7 fc0 sc0 ls0 ws0">
                                        the <span class="_ _1"></span>services of <span class="_ _1"></span>this
                                        Contract. <span class="_ _8"></span>Violation <span class="_ _2"></span>of this{" "}
                                        <span class="_ _8"></span>policy will <span class="_ _1"></span>result{" "}
                                        <span class="_ _1"></span>in <span class="_ _1"></span>immediate removal{" "}
                                        <span class="_ _2"></span>of the <span class="_ _1"></span>Provider{" "}
                                        <span class="_ _1"></span>from his <span class="_ _1"></span>or{" "}
                                        <span class="_ _1"></span>her <span class="_ _1"></span>duties{" "}
                                        <span class="_ _1"></span>and <span class="_ _2"></span>possible immediate{" "}
                                        <span class="_ _1"></span>termination{" "}
                                      </div>
                                      <div class="t m0 x7 h17 ya9 ff2 fs7 fc0 sc0 ls0 ws0">of this Contract.</div>
                                      <div class="t m6 x7 h17 yaa ff2 fs7 fc0 sc0 ls0 ws0">29.</div>
                                      <div class="t m0 x2e h17 yaa ff1 fs7 fc0 sc0 ls0 ws0">
                                        GOVERNOR’S EXECUTIVE <span class="_ _2"></span>ORDER. <span class="_ _2"></span>
                                        <span class="ff2">
                                          California Governor <span class="_ _2"></span>Newsom issued{" "}
                                          <span class="_ _2"></span>Order <span class="_ _2"></span>N-6-22 requiring{" "}
                                          <span class="_ _2"></span>compliance with <span class="_ _2"></span>the{" "}
                                          <span class="_ _2"></span>federal Economic <span class="_ _2"></span>Sanction{" "}
                                        </span>
                                      </div>
                                      <div class="t m0 x7 h17 yab ff2 fs7 fc0 sc0 ls0 ws0">
                                        imposed in response to Russia{" "}
                                      </div>
                                      <div class="t m0 x2f h19 yac ff2 fs8 fc0 sc0 ls0 ws0">5</div>
                                      <div class="t m0 x25 h17 yab ff2 fs7 fc0 sc0 ls0 ws0">
                                        {" "}
                                        s action in Ukraine. See attached <span class="_ _2"></span>Ceuification.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel header="Supplemental Agreement">
                                <div>
                                  <div class="t m0 x7 hc yad ff1 fs5 fc0 sc0 ls0 ws0">
                                    The undersigned <span class="ff2">Agrees as follows:</span>
                                  </div>

                                  <div class="t m0 x30 h1a yae ff1 fs7 fc0 sc0 ls0 ws0">SUPPLEMENTAL AGREEMENT</div>
                                  <div class="t m1 x31 h1b yaf ff1 fs3 fc0 sc0 ls0 ws0">
                                    Specialized Services for Students and Families
                                  </div>
                                  <div class="t m0 x32 hc yad ff2 fs5 fc0 sc0 ls0 ws0">
                                    agency unless comparable services are not available elsewhere or{" "}
                                  </div>
                                  <div class="t m0 x32 hc yb0 ff2 fs5 fc0 sc0 ls0 ws0">
                                    the family specifically requests services offered by clinician
                                  </div>
                                  <div class="t m7 x7 h17 yb1 ff2 fs7 fc0 sc0 ls0 ws0">1.</div>
                                  <div class="t m1 x2a h17 yb1 ff2 fs7 fc0 sc0 ls0 ws0">
                                    To cooperate with school personnel to ensure fair and <span class="_ _0"></span>
                                    equitable
                                  </div>
                                  <div class="t m0 x7 hc yb2 ff2 fs5 fc0 sc0 ls0 ws0">
                                    availability of services to all families.
                                  </div>
                                  <div class="t m7 x7 hc yb3 ff2 fs5 fc0 sc0 ls0 ws0">2.</div>
                                  <div class="t m0 x2a hc yb3 ff2 fs5 fc0 sc0 ls0 ws0">
                                    To support District and school policies and standards.
                                  </div>
                                  <div class="t m7 x7 h17 yb4 ff2 fs7 fc0 sc0 ls0 ws0">3.</div>
                                  <div class="t m1 x2a h17 yb4 ff2 fs7 fc0 sc0 ls0 ws0">
                                    To work with groups of students and/or parents when possible{" "}
                                    <span class="_ _0"></span>to
                                  </div>
                                  <div class="t m0 x32 h17 yb1 ff2 fs7 fc0 sc0 ls0 ws0">
                                    (which should be documented along with referrals to alternative
                                  </div>
                                  <div class="t m0 x32 hc yb2 ff2 fs5 fc0 sc0 ls0 ws0">agencies).</div>
                                  <div class="t m0 x32 hc yb3 ff2 fs5 fc0 sc0 ls0 ws0">
                                    5. To provide licensed personnel or fully-supervised interns for all{" "}
                                  </div>
                                  <div class="t m0 x32 hc yb5 ff2 fs5 fc0 sc0 ls0 ws0">services.</div>
                                  <div class="t m1 x7 h17 yb6 ff2 fs7 fc0 sc0 ls0 ws0">
                                    ensure that <span class="_ _8"></span>as many <span class="_ _1"></span>families are{" "}
                                    <span class="_ _1"></span>served as <span class="_ _1"></span>possible.{" "}
                                    <span class="_ _1"></span>Marital <span class="_ _2"></span>counseling
                                    <span class="_ _13"> </span>6. <span class="_ _1"></span>To{" "}
                                    <span class="_ _8"></span>maintain appropriate insurance as required{" "}
                                    <span class="_ _1"></span>by the
                                    <span class="_ _8"></span>District.{" "}
                                  </div>
                                  <div class="t m1 x7 h17 yb7 ff2 fs7 fc0 sc0 ls0 ws0">
                                    is not an expected use of school-based clinical staff.
                                  </div>
                                  <div class="t m8 x7 hc yb8 ff2 fs5 fc0 sc0 ls0 ws0">4.</div>
                                  <div class="t m0 x2a hc yb8 ff2 fs5 fc0 sc0 ls0 ws0">
                                    To refer students and families in need of(in-depth, long-term){" "}
                                  </div>
                                  <div class="t m0 x7 hc yb9 ff2 fs5 fc0 sc0 ls0 ws0">
                                    specialized <span class="_ _7"></span>services <span class="_ _8"></span>to{" "}
                                    <span class="_ _0"></span>appropriate <span class="_ _8"></span>community
                                    <span class="_ _7"></span>agencies <span class="_ _8"></span>whenever{" "}
                                  </div>
                                  <div class="t m0 x7 hc yba ff2 fs5 fc0 sc0 ls0 ws0">
                                    possible. It is inappropriate for a clinic to refer its own{" "}
                                    <span class="_ _0"></span>agency
                                  </div>
                                  <div class="t m0 x33 hc ybb ff2 fs5 fc0 sc0 ls0 ws0">
                                    Signature<span class="_ _14"> </span>
                                    <span class="fs7">Date</span>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel header="Hold Harmless and Indemnification Agreement">
                                <div>
                                  <div id="pf5" class="pf w0 h0" data-page-no="5">
                                    <div class="pc pc5 w0 h0">
                                      <img class="bi x34 ybd w13 h1c" alt="" src={bg5} />
                                      <div class="t m1 x35 h1d ybe ff3 fs0 fc0 sc0 ls0 ws0">
                                        GlendaleUnifiedSchoolDistrict
                                      </div>
                                      <div class="t m0 x36 h1e ybf ff3 fs6 fc0 sc0 ls0 ws0">Glendale, California</div>
                                      <div class="t m0 x25 h1d yc0 ff3 fs0 fc0 sc0 ls0 ws0">
                                        HOLD HARMLESS AND INDEMNIFICATION AGREEMENT
                                      </div>
                                      <div class="t m0 x34 h1d yc1 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Provider <span class="_ _7"></span>agrees <span class="_ _0"></span>at{" "}
                                        <span class="_ _0"></span>all <span class="_ _15"></span>times{" "}
                                        <span class="_ _15"></span>to <span class="_ _15"></span>protect,{" "}
                                        <span class="_ _7"></span>indemnify,
                                        <span class="_ _7"></span>and <span class="_ _0"></span>hold{" "}
                                        <span class="_ _15"></span>the <span class="_ _15"></span>Glendale{" "}
                                        <span class="_ _0"></span>Unified <span class="_ _15"></span>School{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yc2 ff3 fs0 fc0 sc0 ls0 ws0">
                                        District, <span class="_ _15"></span>its <span class="_ _16"></span>Board{" "}
                                        <span class="_ _16"></span>of <span class="_ _16"></span>Trustees,
                                        <span class="_ _15"></span>officers, <span class="_ _0"></span>employees,{" "}
                                        <span class="_ _0"></span>members, <span class="_ _0"></span>representatives,{" "}
                                        <span class="_ _17"></span>agents, <span class="_ _15"></span>guests,{" "}
                                      </div>
                                      <div class="t m0 x34 h1d yc3 ff3 fs0 fc0 sc0 ls0 ws0">
                                        invitee, <span class="_ _17"></span>and/or <span class="_ _16"></span>employees{" "}
                                        <span class="_ _16"></span>free <span class="_ _17"></span>and
                                        <span class="_ _17"></span>harmless, <span class="_ _16"></span>and{" "}
                                        <span class="_ _17"></span>to
                                        <span class="_ _17"></span>provide <span class="_ _17"></span>legal{" "}
                                        <span class="_ _17"></span>defense, <span class="_ _17"></span>from{" "}
                                        <span class="_ _16"></span>any
                                        <span class="_ _17"></span>and <span class="_ _17"></span>all{" "}
                                      </div>
                                      <div class="t m5 x34 h1f yc4 ff3 fs9 fc0 sc0 ls0 ws0">
                                        liabilities, claims, losses, judgments, damage, demands or expenses resulting
                                        from the{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yc5 ff3 fs0 fc0 sc0 ls0 ws0">
                                        services provided by the Provider, Provider&apos;s use or occupancy of the
                                        District&apos;s facilities and{" "}
                                      </div>
                                      <div class="t m0 x34 h1f yc6 ff3 fs9 fc0 sc0 ls0 ws0">
                                        premises <span class="_ _16"></span>[including
                                        <span class="_ _17"></span>travel <span class="_ _17"></span>to{" "}
                                        <span class="_ _17"></span>and <span class="_ _17"></span>from{" "}
                                        <span class="_ _17"></span>said <span class="_ _17"></span>facilities
                                        <span class="_ _17"></span>and <span class="_ _17"></span>premises]{" "}
                                        <span class="_ _15"></span>and/or <span class="_ _16"></span>the{" "}
                                        <span class="_ _17"></span>active
                                        <span class="_ _17"></span>or{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yc7 ff3 fs0 fc0 sc0 ls0 ws0">
                                        passive <span class="_ _0"></span>negligence <span class="_ _8"></span>of{" "}
                                        <span class="_ _15"></span>the <span class="_ _15"></span>Provide
                                        <span class="_ _2"></span>r <span class="_ _7"></span>or{" "}
                                        <span class="_ _0"></span>of <span class="_ _15"></span>the{" "}
                                        <span class="_ _15"></span>District, <span class="_ _7"></span>its
                                        <span class="_ _15"></span>Board <span class="_ _0"></span>of{" "}
                                        <span class="_ _0"></span>Trustees,
                                        <span class="_ _7"></span>officers, <span class="_ _7"></span>employees,{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yc8 ff3 fs0 fc0 sc0 ls0 ws0">
                                        members, representatives, agents, guests, invitee, and/or employees,
                                        specifically including,{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yc9 ff3 fs0 fc0 sc0 ls0 ws0">
                                        without limitation, any liability, claim, loss, judgment, damage, demand, or
                                        expense, arising{" "}
                                      </div>
                                      <div class="t m0 x34 h1d yca ff3 fs0 fc0 sc0 ls0 ws0">
                                        by reason <span class="_ _2"></span>of:
                                      </div>
                                      <div class="t m9 x37 h1f ycb ff3 fs9 fc0 sc0 ls0 ws0">1.</div>
                                      <div class="t m0 x38 h1f ycb ff3 fs9 fc0 sc0 ls0 ws0">
                                        the <span class="_ _15"></span>loss <span class="_ _7"></span>of{" "}
                                        <span class="_ _8"></span>or <span class="_ _0"></span>damage{" "}
                                        <span class="_ _0"></span>to <span class="_ _0"></span>any{" "}
                                        <span class="_ _7"></span>of <span class="_ _0"></span>the{" "}
                                        <span class="_ _15"></span>District&apos;s <span class="_ _7"></span>facilities{" "}
                                        <span class="_ _1"></span>or <span class="_ _0"></span>premises
                                        <span class="_ _7"></span>includin<span class="_ _2"></span>g{" "}
                                        <span class="_ _0"></span>any
                                      </div>
                                      <div class="t m0 x38 h1d ycc ff3 fs0 fc0 sc0 ls0 ws0">
                                        building, structure, or improvement thereon, or any equipment to be used
                                        therein;
                                      </div>
                                      <div class="t m9 x37 h1d ycd ff3 fs0 fc0 sc0 ls0 ws0">2.</div>
                                      <div class="t m0 x38 h1d ycd ff3 fs0 fc0 sc0 ls0 ws0">
                                        the injury to or death of any person including, but not limited to, the
                                        officers,{" "}
                                      </div>
                                      <div class="t m5 x38 h1d yce ff3 fs0 fc0 sc0 ls0 ws0">
                                        members, <span class="_ _15"></span>employees,
                                        <span class="_ _0"></span>representatives, <span class="_ _16"></span>agents,{" "}
                                        <span class="_ _15"></span>guests, <span class="_ _15"></span>invitee,{" "}
                                        <span class="_ _15"></span>and/or <span class="_ _15"></span>employees{" "}
                                        <span class="_ _15"></span>of
                                      </div>
                                      <div class="t m0 x38 h1f ycf ff3 fs9 fc0 sc0 ls0 ws0">
                                        the Provider or of the District; <span class="_ _0"></span>or
                                      </div>
                                      <div class="t m9 x37 h1f yd0 ff3 fs9 fc0 sc0 ls0 ws0">3.</div>
                                      <div class="t m5 x38 h1f yd0 ff3 fs9 fc0 sc0 ls0 ws0">
                                        damage <span class="_ _0"></span>to <span class="_ _7"></span>any{" "}
                                        <span class="_ _7"></span>property <span class="_ _1"></span>arising
                                        <span class="_ _0"></span>from <span class="_ _7"></span>the{" "}
                                        <span class="_ _7"></span>use, <span class="_ _7"></span>possession,{" "}
                                        <span class="_ _1"></span>selection, <span class="_ _1"></span>delivery, return,
                                      </div>
                                      <div class="t m0 x38 h1d yd1 ff3 fs0 fc0 sc0 ls0 ws0">
                                        condition or operation of the District&apos;s facilities.
                                      </div>
                                      <div class="t m5 x38 h1f yd2 ff3 fs9 fc0 sc0 ls0 ws0">
                                        Provider <span class="_ _15"></span>further <span class="_ _15"></span>agrees{" "}
                                        <span class="_ _15"></span>to <span class="_ _16"></span>reimburse
                                        <span class="_ _16"></span>the <span class="_ _17"></span>District{" "}
                                        <span class="_ _0"></span>for
                                        <span class="_ _16"></span>all <span class="_ _16"></span>liabilities,{" "}
                                        <span class="_ _0"></span>claims, <span class="_ _15"></span>losses,{" "}
                                      </div>
                                      <div class="t m5 x38 h1d yd3 ff3 fs0 fc0 sc0 ls0 ws0">
                                        judgments, damage, demands, expenses, fines, penalties, including reasonable{" "}
                                      </div>
                                      <div class="t ma x38 h1f yd4 ff3 fs9 fc0 sc0 ls0 ws0">
                                        attorneys&apos; fees <span class="_ _7"></span>imposed or{" "}
                                        <span class="_ _1"></span>incurred <span class="_ _8"></span>by
                                        <span class="_ _8"></span>the <span class="_ _7"></span>District because{" "}
                                        <span class="_ _8"></span>of <span class="_ _8"></span>the{" "}
                                        <span class="_ _8"></span>Provider&apos;s
                                        <span class="_ _2"></span>use <span class="_ _8"></span>or{" "}
                                      </div>
                                      <div class="t m5 x38 h1d yd5 ff3 fs0 fc0 sc0 ls0 ws0">
                                        occupancy <span class="_ _8"></span>of <span class="_ _0"></span>the{" "}
                                        <span class="_ _0"></span>District&apos;s <span class="_ _7"></span>facilities,{" "}
                                        <span class="_ _1"></span>access <span class="_ _7"></span>to
                                        <span class="_ _0"></span>said <span class="_ _7"></span>facilities{" "}
                                        <span class="_ _1"></span>and
                                        <span class="_ _0"></span>premises, <span class="_ _8"></span>and/or{" "}
                                      </div>
                                      <div class="t m5 x38 h1d yd6 ff3 fs0 fc0 sc0 ls0 ws0">
                                        active <span class="_ _7"></span>or <span class="_ _0"></span>passive{" "}
                                        <span class="_ _7"></span>negligence of<span class="_ _1"></span>
                                        <span class="_ _7"></span>the <span class="_ _0"></span>Provider{" "}
                                        <span class="_ _8"></span>or <span class="_ _7"></span>of{" "}
                                        <span class="_ _7"></span>the <span class="_ _15"></span>District,{" "}
                                        <span class="_ _8"></span>its <span class="_ _0"></span>Board{" "}
                                        <span class="_ _8"></span>of <span class="_ _0"></span>Trustees,{" "}
                                      </div>
                                      <div class="t m5 x38 h1d yd7 ff3 fs0 fc0 sc0 ls0 ws0">
                                        officers, <span class="_ _7"></span>members, <span class="_ _1"></span>
                                        representatives, <span class="_ _0"></span>agents, <span class="_ _7"></span>
                                        guests, <span class="_ _1"></span>invitee, <span class="_ _8"></span>and/or
                                        <span class="_ _1"></span>employees.
                                      </div>
                                      <div class="t m5 x34 h1d yd8 ff3 fs0 fc0 sc0 ls0 ws0">
                                        THE UNDERSIGNED HAS READ AND VOLUNTARILY SIGNSTHE RELEASE AND WAIVER OF
                                      </div>
                                      <div class="t ma x34 h1d yd9 ff3 fs0 fc0 sc0 ls0 ws0">
                                        LIABILITY AND INDEMNITY AGREEMENT, and further agrees that no oral
                                        representation,{" "}
                                      </div>
                                      <div class="t m5 x34 h1d yda ff3 fs0 fc0 sc0 ls0 ws0">
                                        statements of inducement apart from the foregoing written agreement have been
                                        made.
                                      </div>
                                      <div class="t mb x39 h1d ydb ff3 fs0 fc0 sc0 ls0 ws0">
                                        I HAVE READ THIS RELEASE.
                                      </div>
                                      <div class="t m5 x34 h1d ydc ff3 fs0 fc0 sc0 ls0 ws0">Date</div>
                                      <div class="t m0 x39 h1d ydd ff3 fs0 fc0 sc0 ls0 ws0">Signature of Provider</div>
                                      <div class="t m0 x39 h1d yde ff3 fs0 fc0 sc0 ls0 ws0">Print Name</div>
                                    </div>
                                    <div
                                      class="pi"
                                      data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
                                    ></div>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel header="Retirement Status Statement">
                                <div>
                                  <div id="pf6" class="pf w0 h0" data-page-no="6">
                                    <div class="pc pc6 w0 h0">
                                      <img class="bi x12 ydf w14 h20" alt="" src={bg6} />
                                      <div class="t m1 x35 h1d ybe ff3 fs0 fc0 sc0 ls0 ws0">
                                        GlendaleUnifiedSchoolDistrict
                                      </div>
                                      <div class="t m0 x36 h1e ybf ff3 fs6 fc0 sc0 ls0 ws0">Glendale, California</div>
                                      <div class="t m5 x3a h1d ye0 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Personal Services Agreement{" "}
                                      </div>
                                      <div class="t m0 x31 h1d ye1 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Retirement Status Statement
                                      </div>
                                      <div class="t m5 x34 h1d ye2 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Are you a State Teachers Retirement System (STRS) retiree?
                                      </div>
                                      <div class="t ma x34 h1d ye3 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Are you a California Public Employees Retirement System (CaIPERS){" "}
                                      </div>
                                      <div class="t m5 x34 h1d ye4 ff3 fs0 fc0 sc0 ls0 ws0">retiree?</div>
                                      <div class="t m0 x34 h1d ye5 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Note: The District will be reporting your earnings or hours to the appropriate
                                        retirement{" "}
                                      </div>
                                      <div class="t m5 x34 h1d ye6 ff3 fs0 fc0 sc0 ls0 ws0">
                                        system. <span class="_ _7"></span>You <span class="_ _8"></span>are{" "}
                                        <span class="_ _7"></span>responsible <span class="_ _1"></span>for
                                        <span class="_ _1"></span>monitoring <span class="_ _1"></span>your{" "}
                                        <span class="_ _8"></span>work
                                        <span class="_ _1"></span>hours <span class="_ _8"></span>or{" "}
                                        <span class="_ _1"></span>earnings
                                        <span class="_ _8"></span>to <span class="_ _8"></span>make{" "}
                                        <span class="_ _1"></span>sure <span class="_ _8"></span>you{" "}
                                        <span class="_ _8"></span>do{" "}
                                      </div>
                                      <div class="t m0 x34 h1d ye7 ff3 fs0 fc0 sc0 ls0 ws0">
                                        not exceed your retirement <span class="_ _11"></span>limit.
                                      </div>
                                      <div class="t m0 x34 h1d ye8 ff3 fs0 fc0 sc0 ls0 ws0">Name (Print)</div>
                                      <div class="t m0 x34 h1d ye9 ff3 fs0 fc0 sc0 ls0 ws0">Signature of Provider</div>
                                      <div class="t m0 x34 h1d yea ff3 fs0 fc0 sc0 ls0 ws0">Date</div>
                                    </div>
                                    <div
                                      class="pi"
                                      data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
                                    ></div>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel header="Certification Regarding Governor  Executive order N-6-22">
                                <div>
                                  <div id="pf7" class="pf w0 h0" data-page-no="7">
                                    <div class="pc pc7 w0 h0">
                                      <img class="bi x12 yeb w15 h21" alt="" src={bg7} />
                                      <div class="t m1 x3b h1d yec ff3 fs0 fc0 sc0 ls0 ws0">
                                        GlendaleUnifiedSchoolDistrict
                                      </div>
                                      <div class="t m0 x3c h1e yed ff3 fs6 fc0 sc0 ls0 ws0">Glendale, California</div>
                                      <div class="t m5 x3d h22 yee ff3 fsa fc0 sc0 ls0 ws0">
                                        CERTIFICATION REGARDING{" "}
                                      </div>
                                      <div class="t mb x3e h22 yef ff3 fsa fc0 sc0 ls0 ws0">
                                        GOVERNOR EXECUTIVE ORDER N-6-22
                                      </div>
                                      <div class="t ma x12 h1f yf0 ff3 fs9 fc0 sc0 ls0 ws0">
                                        On <span class="_ _17"></span>March <span class="_ _16"></span>4,{" "}
                                        <span class="_ _17"></span>2022, <span class="_ _16"></span>California
                                        <span class="_ _15"></span>Governor <span class="_ _15"></span>Newsom{" "}
                                        <span class="_ _15"></span>issued <span class="_ _15"></span>Order{" "}
                                        <span class="_ _16"></span>N-6-22
                                        <span class="_ _16"></span>requiring <span class="_ _17"></span>state{" "}
                                        <span class="_ _17"></span>agencies{" "}
                                      </div>
                                      <div class="t m5 x12 h1d yf1 ff3 fs0 fc0 sc0 ls0 ws0">
                                        to <span class="_ _17"></span>take <span class="_ _15"></span>steps{" "}
                                        <span class="_ _15"></span>to <span class="_ _15"></span>ensure{" "}
                                        <span class="_ _7"></span>any <span class="_ _15"></span>agency{" "}
                                        <span class="_ _7"></span>and <span class="_ _15"></span>entity{" "}
                                        <span class="_ _0"></span>under <span class="_ _0"></span>contract
                                        <span class="_ _8"></span>with <span class="_ _16"></span>state{" "}
                                        <span class="_ _0"></span>agencies
                                        <span class="_ _7"></span>comply <span class="_ _0"></span>with{" "}
                                      </div>
                                      <div class="t m0 x12 h1d yf2 ff3 fs0 fc0 sc0 ls0 ws0">the Federal Order:</div>
                                      <div class="t m0 x12 h1d yf3 ff3 fs0 fc0 sc0 ls0 ws0">
                                        (htt<span class="_ _18"> </span>www.
                                      </div>
                                      <div class="t m5 x12 h1d yf4 ff3 fs0 fc0 sc0 ls0 ws0">
                                        Order.pdf; “State <span class="_ _17"></span>Order”).
                                      </div>
                                      <div class="t m0 x3f h1d yf3 ff3 fs0 fc0 sc0 ls0 ws0">
                                        -content<span class="_ _19"> </span>loads 2022 03
                                        <span class="_ _5"></span>3.4.22-Russia-Ukraine-Executive-
                                      </div>
                                      <div class="t m0 x12 h1d yf5 ff3 fs0 fc0 sc0 ls0 ws0">
                                        If <span class="_ _15"></span>you <span class="_ _16"></span>enter{" "}
                                        <span class="_ _15"></span>into <span class="_ _15"></span>a{" "}
                                        <span class="_ _16"></span>contract <span class="_ _7"></span>with{" "}
                                        <span class="_ _17"></span>the
                                        <span class="_ _16"></span>District, <span class="_ _15"></span>you{" "}
                                        <span class="_ _16"></span>must
                                        <span class="_ _15"></span>comply <span class="_ _15"></span>with{" "}
                                        <span class="_ _16"></span>the
                                        <span class="_ _16"></span>economic <span class="_ _15"></span>sanctions{" "}
                                      </div>
                                      <div class="t m5 x12 h1f yf6 ff3 fs9 fc0 sc0 ls0 ws0">
                                        imposed <span class="_ _8"></span>in <span class="_ _8"></span>response{" "}
                                        <span class="_ _1"></span>to <span class="_ _0"></span>Russia’s actions{" "}
                                        <span class="_ _8"></span>in <span class="_ _7"></span>Ukraine, including{" "}
                                        <span class="_ _7"></span>the <span class="_ _7"></span>orders{" "}
                                        <span class="_ _1"></span>and <span class="_ _8"></span>sanctions{" "}
                                      </div>
                                      <div class="t m0 x12 h1d yf7 ff3 fs0 fc0 sc0 ls0 ws0">
                                        identified on <span class="_ _0"></span>the <span class="_ _7"></span>U.S.{" "}
                                        <span class="_ _1"></span>Department <span class="_ _4"></span>of{" "}
                                        <span class="_ _8"></span>the <span class="_ _7"></span>Treasury website:
                                      </div>
                                      <div class="t m0 x40 h1d yf8 ff3 fs0 fc0 sc0 ls0 ws0">
                                        (htt <span class="_ _5"> </span>home.treasu<span class="_ _1a"> </span>-issues
                                        financial-sanctions sanctions- <span class="_ _d"></span>rams-and-
                                      </div>
                                      <div class="t m0 x5 h1d yf9 ff3 fs0 fc0 sc0 ls0 ws0">
                                        ukraine-russia- related-sanctions).
                                      </div>
                                      <div class="t m0 x12 h1d yfa ff3 fs0 fc0 sc0 ls0 ws0">
                                        As <span class="_ _8"></span>part of <span class="_ _1"></span>this{" "}
                                        <span class="_ _1"></span>procurement, <span class="_ _2"></span>if
                                        <span class="_ _8"></span>the <span class="_ _8"></span>contract value{" "}
                                        <span class="_ _7"></span>of
                                        <span class="_ _8"></span>this <span class="_ _8"></span>pro
                                        <span class="_ _2"></span>curement <span class="_ _2"></span>is{" "}
                                        <span class="_ _8"></span>$5 million <span class="_ _7"></span>or{" "}
                                        <span class="_ _1"></span>more,{" "}
                                      </div>
                                      <div class="t m0 x12 h1d yfb ff3 fs0 fc0 sc0 ls0 ws0">
                                        please include in your Response the <span class="_ _0"></span>following:
                                      </div>
                                      <div class="t mc x41 h1d yfc ff3 fs0 fc0 sc0 ls0 ws0">(1)</div>
                                      <div class="t m5 x42 h1d yfc ff3 fs0 fc0 sc0 ls0 ws0">
                                        a <span class="_ _7"></span>statement <span class="_ _1"></span>that{" "}
                                        <span class="_ _8"></span>you <span class="_ _7"></span>are{" "}
                                        <span class="_ _7"></span>in<span class="_ _2"></span>{" "}
                                        <span class="_ _0"></span>compliance <span class="_ _1"></span>with{" "}
                                        <span class="_ _0"></span>the <span class="_ _7"></span>required{" "}
                                        <span class="_ _1"></span>economic <span class="_ _8"></span>sanctions{" "}
                                        <span class="_ _1"></span>of
                                      </div>
                                      <div class="t m0 x41 h1d yfd ff3 fs0 fc0 sc0 ls0 ws0">
                                        the Federal and State <span class="_ _0"></span>Orders;
                                      </div>
                                      <div class="t mc x41 h1d yfe ff3 fs0 fc0 sc0 ls0 ws0">(2)</div>
                                      <div class="t m5 x42 h1d yfe ff3 fs0 fc0 sc0 ls0 ws0">
                                        the <span class="_ _7"></span>steps <span class="_ _7"></span>you{" "}
                                        <span class="_ _8"></span>have <span class="_ _7"></span>taken{" "}
                                        <span class="_ _7"></span>in <span class="_ _7"></span>response{" "}
                                        <span class="_ _1"></span>to <span class="_ _7"></span>Russia&apos;s{" "}
                                        <span class="_ _1"></span>actions <span class="_ _8"></span>in
                                        <span class="_ _8"></span>Ukraine, <span class="_ _1"></span>including,{" "}
                                        <span class="_ _8"></span>but{" "}
                                      </div>
                                      <div class="t m5 x41 h1f yff ff3 fs9 fc0 sc0 ls0 ws0">
                                        not <span class="_ _2"></span>limited <span class="_ _2"></span>to,{" "}
                                        <span class="_ _2"></span>desisting <span class="_ _2"></span>from{" "}
                                        <span class="_ _2"></span>making <span class="_ _2"></span>new{" "}
                                        <span class="_ _2"></span>investments
                                        <span class="_ _2"></span>in, <span class="_ _2"></span>or{" "}
                                        <span class="_ _2"></span>engaging <span class="_ _2"></span>in{" "}
                                        <span class="_ _2"></span>financial{" "}
                                      </div>
                                      <div class="t ma x41 h1f y100 ff3 fs9 fc0 sc0 ls0 ws0">
                                        transactions <span class="_ _b"></span>with,
                                        <span class="_ _5"></span>Russian <span class="_ _b"></span>entities,{" "}
                                        <span class="_ _5"></span>not
                                        <span class="_ _b"></span>transferring <span class="_ _b"></span>technology{" "}
                                        <span class="_ _5"></span>to <span class="_ _b"></span>Russia{" "}
                                        <span class="_ _b"></span>or <span class="_ _5"></span>Russian{" "}
                                      </div>
                                      <div class="t m0 x41 h1d y101 ff3 fs0 fc0 sc0 ls0 ws0">
                                        entities, <span class="_ _0"></span>and <span class="_ _15"></span>directly{" "}
                                        <span class="_ _0"></span>providing <span class="_ _15"></span>support{" "}
                                        <span class="_ _0"></span>to <span class="_ _17"></span>the{" "}
                                        <span class="_ _16"></span>government <span class="_ _7"></span>and{" "}
                                        <span class="_ _15"></span>people
                                        <span class="_ _0"></span>of <span class="_ _17"></span>Ukraine.
                                      </div>
                                      <div class="t ma x12 h1d y102 ff3 fs0 fc0 sc0 ls0 ws0">Print Name:</div>
                                      <div class="t m0 x29 h1d y102 ff3 fs0 fc0 sc0 ls0 ws0"> </div>
                                      <div class="t m0 x12 h1d y103 ff3 fs0 fc0 sc0 ls0 ws0">Signature:</div>
                                      <div class="t m7 x29 h1d y103 ff3 fs0 fc0 sc0 ls0 ws0"> </div>
                                      <div class="t m0 x12 h1d y104 ff3 fs0 fc0 sc0 ls0 ws0">Date:</div>
                                      <div class="t m7 x29 h1d y104 ff3 fs0 fc0 sc0 ls0 ws0"> </div>
                                      <div class="c x43 y105 w16 h23">
                                        <div class="t m0 x21 h1d y106 ff3 fs0 fc0 sc0 ls0 ws0">
                                          country -information
                                        </div>
                                      </div>
                                      <a class="l" href="http://www/">
                                        <div
                                          class="d md"
                                          style={{
                                            borderStyle:
                                              "none;position:absolute;left:112.949997px;bottom:574.096985px;width:29.332016px;height:13.799011px;background-color:rgba(255,255,255,0.000001);"
                                          }}
                                        ></div>
                                      </a>
                                    </div>
                                    <div
                                      class="pi"
                                      data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
                                    ></div>
                                  </div>
                                </div>
                              </TabPanel>
                            </TabView>
                          </div>
                          <div className="absolute bottom-0 right-0 left-0 grid grid-cols-2  ">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(true);
                                  SetTermsAndConditions(false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    saveBasicInfo();
                                    setConfirmVisible2(true);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(false);
                                    SetTermsAndConditions(false);
                                    SetW9Detailes(false);
                                    SetEddDetailes(true);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {eddDetailes === true ? (
                        <div>
                          <div className="text-[20px] text-[#101828]  font-medium">
                            Employment Development Department State of California
                          </div>
                          <div className="text-[18px] text-[#101828] mt-2 font-medium">
                            Report of Independent Contractor(s) Details
                          </div>

                          <form>
                            <div className="mt-2 grid grid-cols-2 gap-8">
                              <div className="">
                                <div className="col ">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Name<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <Dropdown
                                    value={selectedEmployee}
                                    onChange={e => {
                                      setSelectedEmployee(e.value);
                                      //set selected id employee data
                                      allEmployeeDetails.map(currentItem => {
                                        if (currentItem.id === e.value.code) {
                                          setSelectedEmployeeDetails(currentItem);
                                        }
                                      });
                                    }}
                                    options={empCodeList}
                                    optionLabel="name"
                                    placeholder="Select a Employee"
                                    filter
                                    // valueTemplate={selectedCountryTemplate}
                                    className="w-full md:w-14rem"
                                  />
                                </div>

                                <div className="col ">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Date<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <div className="relative custp-calender">
                                    <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                    <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                    <div className="card flex justify-content-center">
                                      <Calendar
                                        onChange={e => {
                                          setStartDate(e.target.value);
                                        }}
                                        value={startDate}
                                        placeholder="Start Date"
                                        className="w-full h-11"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col mt-1.5">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    CA Employer Account No<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>
                              </div>

                              <div className="">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Contact Person<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <input
                                  onChange={e => setAssighnmentTitle(e.target.value)}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Types Services"
                                />

                                <div className="col">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Federal ID No<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Types Services"
                                  />
                                </div>

                                <div className="col">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Social Security No<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Types Services"
                                  />
                                </div>
                              </div>
                            </div>
                            <label
                              className="text-[#344054] text-[14px] mt-4 xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Address
                            </label>
                            <div className="flex gap-3">
                              <input
                                type="text"
                                name=""
                                class="py-[6px] text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="State"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="City"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Street Address"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Postal Code"
                              />
                            </div>

                            <label
                              className="text-[#344054] mt-2 text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Phone No<span className="text-[red] pl-0.2">*</span>
                            </label>
                            <input
                              onChange={e => setAssighnmentTitle(e.target.value)}
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                              placeholder="Types Services"
                            />

                            <div className="text-[14px] text-[#101828] mt-2 font-medium">
                              Provider (Independent Contractor)
                            </div>
                            <div className=" grid grid-cols-2 gap-8">
                              <div className="">
                                <div className="col ">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Name<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => setAssighnmentTitle(e.target.value)}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>
                              </div>

                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Social Security No<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <input
                                  onChange={e => setAssighnmentTitle(e.target.value)}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                />
                              </div>
                            </div>

                            <label
                              className="text-[#344054] text-[14px] mt-4 xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Address
                            </label>
                            <div className="flex gap-3">
                              <input
                                type="text"
                                name=""
                                class="py-[6px] text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="State"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="City"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Street Address"
                              />

                              <input
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full"
                                placeholder="Postal Code"
                              />
                            </div>
                            <div className="flex mt-2">
                              <input type="radio" id="html" name="fav_language" value="HTML" />
                              <label
                                className="text-[#344054] ml-1 text-[11px] font-medium  inline-block"
                                for="username"
                              >
                                On Going Contract
                              </label>
                            </div>

                            <div className="grid grid-cols-2 mt-[5vw]  xl:mt-[2.083vw]">
                              <div>
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(false);
                                    SetTermsAndConditions(true);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                  }}
                                  className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                >
                                  <i className="gusd-arrow-line-right mr-1"></i>Previous
                                </a>
                              </div>
                              <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                                <a
                                  // onClick={() => {
                                  //   setShowNextPopUp(false);
                                  // }}
                                  href="javascript:void(0);"
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                >
                                  <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                                </a>
                                {showPreviewPopUp ? (
                                  <a
                                    href="#"
                                    onClick={() => {
                                      saveBasicInfo();
                                      setConfirmVisible2(true);
                                      // setShowPreviewPopUp(true)
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="gusd-check mr-1"></i>Submit
                                  </a>
                                ) : (
                                  <a
                                    href="#"
                                    onClick={() => {
                                      setShowPreviewPopUp(false);
                                      SetBasicInfoPopUp(false);
                                      setPartyDetailesPopUp(false);
                                      SetAttchmentAndDetailes(false);
                                      SetTermsAndConditions(false);
                                      SetW9Detailes(true);
                                      SetEddDetailes(false);
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="gusd-check mr-1"></i>Next
                                  </a>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      ) : null}
                      {w9Detailes === true ? (
                        <div>
                          <div className="text-[24px] xl:text-[1.250vw] font-medium">W9 Details</div>
                          <Image src={w9DetailesPic} imageClassName="ml-6" alt="user" width="550" height="370" />
                          <div className="w-full flex justify-center text-[#101828] text-[16px] mt-4">
                            Department of the Treasury Internal Revenue Service
                          </div>
                          <div className="grid grid-cols-2 mt-[6vw]">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(true);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                // onClick={() => {
                                //   setShowNextPopUp(false);
                                // }}
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    // saveBasicInfo();
                                    // setConfirmVisible2(true)
                                    // // setShowPreviewPopUp(true)
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(true);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(false);
                                    SetTermsAndConditions(false);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                  }}
                                  className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-eye mr-1"></i>Preview
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {previewAndEdit === true ? (
                        <div>
                          <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                            {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                            <ServiceAgreementPdf
                              data={{
                                employeeName: "Abc",
                                employeeId: "Siddhesh",
                                schoolName: "Privte Highschool",
                                dateFrom: moment().format("YYYY-DD-MM"),
                                dateTo: moment().format("YYYY-DD-MM"),
                                subjectName: "Marathi",
                                staffAllocation: "023",
                                accountCharged: "accountCharge",
                                fteUtilized: "fteUtilized"
                              }}
                            />
                          </div>
                          <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                            <div>
                              <a
                                href="#"
                                onClick={() => (showPreviewPopUp ? setShowPreviewPopUp(false) : null)}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              <a
                                // onClick={() => {
                                //   setShowNextPopUp(false);
                                // }}
                                href="javascript:void(0);"
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Saves
                              </a>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    saveBasicInfo();
                                    setConfirmVisible2(true);
                                    // setShowPreviewPopUp(true)
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    //first we check mandatory fields are filled or not

                                    if (selectedEmployee === null) {
                                      toast.error("Please Select Employee Id");
                                      return;
                                    } else if (schoolSelect === "") {
                                      toast.error("Please Select Assignment At");
                                      return;
                                    } else if (assighnmentTitle === "") {
                                      toast.error("Please enter Assighment Title");
                                      return;
                                    } else if (startDate === null) {
                                      toast.error("Please enter From Date");
                                      return;
                                    } else if (endDate === null) {
                                      toast.error("Please enter To Date");
                                      return;
                                    } else if (subjectCode === null) {
                                      toast.error("Please enter To Date");
                                      return;
                                    }

                                    // setShowPreviewPopUp(true)
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* confirmation dialog */}

                  <Dialog
                    header=""
                    visible={confirmVisible2}
                    style={{ width: "30vw" }}
                    onHide={() => {
                      setConfirmVisible2(false);
                      setVisibleEdit(false);
                    }}
                    footer={footerContent1}
                  >
                    <p className="m-0 text-[#0487C8]">
                      <i className="pi pi-check-circle mr-2"></i>
                      <span className="font-medium text-[18px]">This report Has been Successfully Created</span>
                    </p>
                  </Dialog>

                  <div className="col-span-3 sideBarRight openSideDiv">
                    <div className="h-full relative">
                      <div className="text-[24px] xl:text-[1.250vw] font-medium">Employee Details</div>
                      <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">
                        {selectedEmployee ? (
                          <div className="bg-[#D8E7FC] border border-[#D8E7FC] grid grid-cols-12 gap-4">
                            <Avatar
                              className="col-span-3"
                              image="/images/avatar/amyelsner.png"
                              size="xlarge"
                              shape="circle"
                            />
                            <div className="col-span-7">
                              <label
                                className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                for="username"
                              >
                                Name
                              </label>
                              <div className="text-[#101828] text-[12px] font-medium">
                                {selectedEmployeeDetails.employee_name}
                              </div>
                            </div>
                            <i className="gusd-edit col-span-2"></i>
                          </div>
                        ) : null}

                        <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                          <img src={empDetailsImg} class=" mx-auto" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </Layout>

      <Dialog
        className="relative reports-popup"
        visible={visibleNewForm}
        position="right"
        style={{ width: "100vw" }}
        breakpoints={{ "960px": "100vw", "641px": "100vw" }}
        onHide={() => setVisibleNewForm(false)}
        draggable={false}
        resizable={false}
      >
        <div className="fixed inset-0 z-10 overflow-y-auto styled-select">
          <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
            <div className="relative w-full overflow-hidden transition-all transform">
              <div className="grid grid-cols-12 custmCols">
                <div className={`h-full col-span-3 sideBarLeft openSideDiv`}>
                  <button
                    onClick={() => {
                      setShowPreviewPopUp(false);
                      setShowNextPopUp(false);
                    }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                    id="add-family-cancel-btn"
                  >
                    <i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home
                  </button>
                  <div className=" text-[#101828] text-[12px] mt-[7px] font-normal">
                    GUSD 6th Period Teaching Assignment
                  </div>
                  <div className="mt-[32px] xl:[1.667vw]">
                    <ul className="sideTabs">
                      <li>
                        <a
                          href="#"
                          onClick={() => setShowPreviewPopUp(false)}
                          className={`${showPreviewPopUp ? "tab-b active " : "tab-b active activeCheck"}`}
                          data-id="tab1"
                        >
                          <i className="gusd-check text-[1.042vw]"></i>
                          Basic Info
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          // onClick={() =>
                          // setShowPreviewPopUp(true)
                          // }
                          className={`${showPreviewPopUp ? "tab-b active activeCheck" : ""}`}
                          data-id="tab2"
                        >
                          <i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="fixed top-0 left-0 openBtn xl:hidden">
                    <button
                      type="button"
                      className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"
                    >
                      <i className="gusd-arrow-line-right"></i>
                    </button>
                  </div>
                </div>
                <div className="col-span-12 overflow-hidden xl:overflow-auto xl:col-span-6 mScrollCstm ">
                  {/* Form code goes here */}
                  <div className="mt-5 xl:mt-[1.250vw] ">
                    <div className="text-[#113699] text-base xl:text-[0.833vw] font-semibold -tracking-[0.02em]">
                      New Form
                    </div>
                  </div>

                  <div className="bg-[#FFFFFF] rounded-lg">
                    <div className="mt-5 cusdropdown">
                      <div className="px-4 py-4 space-y-3">
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">Employee ID</div>
                          <InputText
                            placeholder="Type ID"
                            onChange={e => setEmployee_Id(e.target.value)}
                            value={employee_Id}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>

                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">Employee name</div>
                          <InputText
                            placeholder="Type Name"
                            onChange={e => setemployeeName(e.target.value)}
                            value={employeeName}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>

                        <div className="flex gap-2">
                          <div>
                            <div className="text-sm xl:text-[0.729vw] text-[#344054] font-medium pb-1 ">
                              Position Title
                            </div>
                            {/* <i className="gusd-search text-[#667085] text-sm absolute top-[19.6rem] z-10"></i> */}
                            <InputText
                              placeholder="To"
                              onChange={e => setpositionTitle(e.target.value)}
                              value={positionTitle}
                              className="w-[14.7vw] text-[16px] text-[#667085] box-shadow-2 "
                            />
                          </div>
                          <div>
                            <div className="text-sm xl:text-[0.729vw] text-[#344054] font-medium pb-1 ">&nbsp;</div>
                            {/* <i className="gusd-search text-[#667085] text-sm absolute top-[19.6rem] z-10"></i> */}
                            <InputText
                              placeholder="From"
                              onChange={e => settransferredPositionTitle(e.target.value)}
                              value={transferredPositionTitle}
                              className="w-[14.7vw] text-[16px] text-[#667085] box-shadow-2"
                            />
                          </div>
                        </div>

                        <div className="flex gap-2">
                          <div>
                            <div className="text-sm xl:text-[0.729vw] text-[#344054] font-medium pb-1 ">
                              Effective Dates
                            </div>
                            <div className="relative custp-calender">
                              <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                              <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                              <div className="card flex justify-content-center">
                                <Calendar
                                  onChange={e => {
                                    setStartDate(e.target.value);
                                  }}
                                  value={startDate}
                                  placeholder="From"
                                  className="w-full text-[16px] text-[#667085] box-shadow-2 calender-af"
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="text-sm xl:text-[0.729vw] text-[#344054] font-medium pb-1 ">&nbsp;</div>
                            <div className="relative custp-calender">
                              <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                              <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                              <div className="card flex justify-content-center">
                                <Calendar
                                  onChange={e => {
                                    setEndDate(e.target.value);
                                  }}
                                  value={startEndDate}
                                  placeholder="To"
                                  className="w-full text-[16px] text-[#667085] box-shadow-2 calender-af"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">Salary Rate</div>
                          <InputText
                            placeholder="Enter the Salary"
                            onChange={e => setsalaryRate(e.target.value)}
                            value={salaryRate}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">
                            Rate of Pay (Not to Exceed){" "}
                          </div>
                          <InputText
                            placeholder="Enter the Rate"
                            onChange={e => setrateofPay(e.target.value)}
                            value={rateofPay}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">Reason</div>
                          <InputText
                            placeholder="Enter the Reason"
                            onChange={e => setreason(e.target.value)}
                            value={reason}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">
                            Funding Source
                          </div>
                          <InputText
                            placeholder="Enter the Source"
                            onChange={e => setfundingSource(e.target.value)}
                            value={fundingSource}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">
                            Account Number
                          </div>
                          <InputText
                            placeholder="Enter the Account Number"
                            onChange={e => setaccountNo(e.target.value)}
                            value={accountNo}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>
                        <div className="">
                          <div className="text-[#344054] text-sm xl:text-[0.729vw] font-medium pb-1">Budget Code</div>
                          <InputText
                            placeholder="Type the Code"
                            onChange={e => setbudgetCode(e.target.value)}
                            value={budgetCode}
                            className="w-full text-[16px] text-[#667085] box-shadow-2 "
                          />
                        </div>

                        <div className="flex items-center justify-end gap-1 xl:gap-[0.521vw] pt-5">
                          <div className="gusd text-left">
                            <Link
                              to=""
                              className="cancelBtnbgnone radius8 mr-3"
                              onClick={() => setVisibleNewForm(false)}
                            >
                              Clear{" "}
                            </Link>
                          </div>

                          <div className="text-right">
                            <Link
                              to=""
                              className="custmBtnbottom blue radius8 pl-4 pr-5 p-2"
                              onClick={BindList_forPersonalActionForm}
                            >
                              <i className="gusd-check mx-1.5 "></i>Apply
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`h-full col-span-3 openSideDiv sideBarRight`}>
                  <div className="relative h-full">
                    <div className="text-[24px] xl:text-[1.250vw] font-medium">Employee Details</div>
                    <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">
                      <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                        <img src={empDetailsImg} class=" mx-auto" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        header={header}
        visible={visibleconfirmationpopup}
        className="ui-grid ui-grid-responsive"
        onHide={() => setConfirmationpopup(false)}
        footer={footerConfirm}
      >
        <p className="text-[#0487C8] ">
          <span className="font-medium text-[16px]"> Your Report has been sent successfully!</span>
        </p>
      </Dialog>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}
